/*
This file is located in the main branch
Last time the file was updated (UTC): [11.11.2024 10:06:50]
Permissions to update outside the main branch: [true]
*/

import { DocumentTitle, useCondition } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { PropsWithChildren } from 'react';
import 'scss/Main.scss';
import './Home.scss';

const NovaWrapper = ({ children }: PropsWithChildren) => (
    <div className="home main-card custom-scrollbar">
        <div className="home__content">{children}</div>
    </div>
);

const ClassicWrapper = ({ children }: PropsWithChildren) => (
    <div className="custom-scrollbar h-100">{children}</div>
);

export default function Home() {
    const { designType } = useGeneralSettingsContext();

    const Wrapper = useCondition(
        designType,
        {
            nova: NovaWrapper,
        },
        ClassicWrapper
    );

    return (
        <DocumentTitle code="BackOfficeHome">
            <Wrapper>
                <h1>Список изменений</h1>
                <h3>v 2.2.532.171</h3>
                <ul>
                    <li>PAYL[683]</li>
                </ul>
                <h3>v 2.2.532.170</h3>
                <ul>
                    <li>added new column (SdSell) in Merchant.tsx</li>
                </ul>
                <h3>v 2.2.532.169</h3>
                <ul>
                    <li>null</li>
                </ul>
                <h3>v 2.2.532.168</h3>
                <ul>
                    <li>null</li>
                </ul>
                <h3>v 2.2.532.167</h3>
                <ul>
                    <li>null</li>
                </ul>
                <h3>v 2.2.532.166</h3>
                <ul>
                    <li>null</li>
                </ul>
                <h3>v 2.2.532.165</h3>
                <ul>
                    <li>PAYL[545]v2</li>
                </ul>
                <h3>v 2.2.532.164</h3>
                <ul>
                    <li>null</li>
                </ul>
                <h3>v 2.2.532.163</h3>
                <ul>
                    <li>Added new productTypes</li>
                </ul>
                <h3>v 2.2.532.162</h3>
                <ul>
                    <li>-rollback uzb[612]</li>
                </ul>
                <h3>v 2.2.532.161</h3>
                <ul>
                    <li>hotfix</li>
                </ul>
                <h3>v 2.2.532.160</h3>
                <ul>
                    <li>uzb[612]</li>
                </ul>
                <h3>v 2.2.532.159</h3>
                <ul>
                    <li>-uzb[429]</li>
                </ul>
                <h3>v 2.2.532.158</h3>
                <ul>
                    <li>PF release version</li>
                </ul>
                <h3>v 2.2.532.157</h3>
                <ul>
                    <li>[UZB-535]</li>
                </ul>
                <h3>v 2.2.532.156</h3>
                <ul>
                    <li>null</li>
                </ul>
                <h3>v 2.2.532.155</h3>
                <ul>
                    <li>refactor-mawd-126</li>
                </ul>
                <h3>v 2.2.532.154</h3>
                <ul>
                    <li>Rollback tasks on test</li>
                </ul>
                <h3>v 2.2.532.153</h3>
                <ul>
                    <li>Add for Merchant Directors filter by outlets in Merchant</li>
                    <li>Add BrandCode bidable for users</li>
                    <li>Filter by BrandCode in Orders, PreOrders, Merchant</li>
                    <li>AutoFilter BrandCode depending on the chosen one BrandCode</li>
                    <li>Add field for AdjustedSum,MerchantReceives, TarrifGroup in Merchant</li>
                </ul>
                <h3>v 2.2.532.152</h3>
                <ul>
                    <li>Hot Fix</li>
                </ul>
                <h3>v 2.2.532.151</h3>
                <ul>
                    <li>Rollback</li>
                </ul>
                <h3>v 2.2.532.150</h3>
                <ul>
                    <li>Remove uzb429 and uzb413 from release version</li>
                </ul>
                <h3>v 2.2.532.149</h3>
                <ul>
                    <li>Remove hardcode brandcode V.0.1</li>
                </ul>
                <h3>v 2.2.532.148</h3>
                <ul>
                    <li>HotFix uzb451</li>
                </ul>
                <h3>v 2.2.532.147</h3>
                <ul>
                    <li>FIX UZB-451</li>
                </ul>
                <h3>v 2.2.532.146</h3>
                <ul>
                    <li>Added INN and PINFL in Outlets</li>
                </ul>
                <h3>v 2.2.532.145</h3>
                <ul>
                    <li>-Recolor rows in merchant workplace</li>
                </ul>
                <h3>v 2.2.532.144</h3>
                <ul>
                    <li>- Comeback uzb429 to test environment</li>
                </ul>
                <h3>v 2.2.532.143</h3>
                <ul>
                    <li>- Remove uzb429 from release version</li>
                </ul>
                <h3>v 2.2.532.142</h3>
                <ul>
                    <li>Bugfix merchant Workplace</li>
                </ul>
                <h3>v 2.2.532.141</h3>
                <ul>
                    <li>Bugfix for test environment (uzb-429)</li>
                </ul>
                <h3>v 2.2.532.140</h3>
                <ul>
                    <li>Bugfix Merchant Workplace</li>
                </ul>
                <h3>v 2.2.532.139</h3>
                <ul>
                    <li>Add new statuses in Merchant Workplace</li>
                </ul>
                <h3>v 2.2.532.138</h3>
                <ul>
                    <li>-Fix for release</li>
                </ul>
                <h3>v 2.2.532.137</h3>
                <ul>
                    <li>uzb-363</li>
                    <li>mobileApp checkbox in MerchantOrderForm</li>
                </ul>
                <h3>v 2.2.532.136</h3>
                <ul>
                    <li>
                        Comment out mobile checkbox im MerchantOrderForm.tsx, he is waiting mobile
                        app release
                    </li>
                </ul>
                <h3>v 2.2.532.135</h3>
                <ul>
                    <li>comment out UZB-363</li>
                </ul>
                <h3>v 2.2.532.134</h3>
                <ul>
                    <li>Fix resources , now work new api methods</li>
                </ul>
                <h3>v 2.2.532.133</h3>
                <ul>
                    <li>
                        Add alert when user tries to close MerchantOrderModal in
                        &quot;clientconfirm&quot; status
                    </li>
                </ul>
                <h3>v 2.2.532.132</h3>
                <ul>
                    <li>
                        Add a button for generating court documents and display it in DocumentsTab
                    </li>
                    <li>Add two new API endpoints with corresponding requests.</li>
                    <li>Add two new SQL roles for using the API requests.</li>
                </ul>
                <h3>v 2.2.532.131</h3>
                <ul>
                    <li>
                        Added formatting mask for productCost, productSum input in
                        MerchantOrderModal
                    </li>
                    <li>
                        Added function numberFromLocaleString in utils/number.ts to convert
                        localized number string to float
                    </li>
                    <li>Applied Prettier formatting to neighboring files affected by changes</li>
                </ul>
                <h3>v 2.2.532.130</h3>
                <ul>
                    <li>Fixed trade org descriptions saving</li>
                </ul>
                <h3>v 2.2.532.129</h3>
                <ul>
                    <li>Added multilanguage descriptions to Trade Orgs</li>
                </ul>
                <h3>v 2.2.532.128</h3>
                <ul>
                    <li>Changed usage limit field to amount</li>
                    <li>Fixed tariff groups props save</li>
                </ul>
                <h3>v 2.2.532.127</h3>
                <ul>
                    <li>Changed credit limit procedure call</li>
                </ul>
                <h3>v 2.2.532.126</h3>
                <ul>
                    <li>Fixed order list query</li>
                </ul>
                <h3>v 2.2.532.125</h3>
                <ul>
                    <li>Fixed alternative limit validation</li>
                    <li>Added limit states as constants</li>
                </ul>
                <h3>v 2.2.532.124</h3>
                <ul>
                    <li>Added new client limit state logic to Merchant WP</li>
                </ul>
                <h3>v 2.2.532.123</h3>
                <ul>
                    <li>Added dates change logic</li>
                </ul>
                <h3>v 2.2.532.122</h3>
                <ul>
                    <li>Added close/open of operational day</li>
                </ul>
                <h3>v 2.2.532.121</h3>
                <ul>
                    <li>Changed text of operational day confirm</li>
                    <li>Changed text of operational day button while it&apos;s open</li>
                </ul>
                <h3>v 2.2.532.120</h3>
                <ul>
                    <li>Added isMobile filed to Merchant Order form.</li>
                    <li>Changed order save</li>
                </ul>
                <h3>v 2.2.532.119</h3>
                <ul>
                    <li>Added validation for image uploads in trade orgs modal WP</li>
                    <li>Added required rule for product category in trade orgs modal WP</li>
                </ul>
                <h3>v 2.2.532.118</h3>
                <ul>
                    <li>Added confirm modal to open day button action</li>
                </ul>
                <h3>v 2.2.532.117</h3>
                <ul>
                    <li>Fixed merchant order validation</li>
                </ul>
                <h3>v 2.2.532.116</h3>
                <ul>
                    <li>Added Operational Day Open Button</li>
                </ul>
                <h3>v 2.2.532.115</h3>
                <ul>
                    <li>Fixed merchant payment get</li>
                </ul>
                <h3>v 2.2.532.114</h3>
                <ul>
                    <li>Add ProductType field in order card</li>
                    <li>Fixed discount validation message</li>
                    <li>Fixed error when Outlet updates</li>
                </ul>
                <h3>v 2.2.532.113</h3>
                <ul>
                    <li>Fixed Discount validation</li>
                    <li>Fixed Outlet Save</li>
                </ul>
                <h3>v 2.2.532.112</h3>
                <ul>
                    <li>Added IsLandingShows column to TradeOrgs for filter them on Landing</li>
                </ul>
                <h3>v 2.2.532.111</h3>
                <ul>
                    <li>Changed Channel filter to dropdown</li>
                </ul>
                <h3>v 2.2.532.110</h3>
                <ul>
                    <li>Changed Product Cost save in Merchant WP.</li>
                </ul>
                <h3>v 2.2.532.109</h3>
                <ul>
                    <li>Added field Client Installment to Order Modal of Merchant WP</li>
                    <li>Chaged calculating of Order Payments in Merchant WP</li>
                </ul>
                <h3>v 2.2.532.108</h3>
                <ul>
                    <li>Fixed final payment date, when order has active loand</li>
                </ul>
                <h3>v 2.2.532.107</h3>
                <ul>
                    <li>Added Product Type column and filter to Orders WP</li>
                    <li>Added Product Type column and filter to PreOrders WP</li>
                </ul>
                <h3>v 2.2.532.106</h3>
                <ul>
                    <li>Added Merchant Receives field to Merchant Order Create Form</li>
                    <li>Renamed Payment field in Merchant Order Create Form</li>
                </ul>
                <h3>v 2.2.532.105</h3>
                <ul>
                    <li>Added TypeWork and Discount to Outlets WP</li>
                    <li>Added TypeWork filter for table to Outlets WP</li>
                </ul>
                <h3>v 2.2.532.104</h3>
                <ul>
                    <li>Fixed trade org edit save error</li>
                    <li>Fixed ui of image upload button</li>
                </ul>
                <h3>v 2.2.532.103</h3>
                <ul>
                    <li>Added &apos;Return&apos; payment source</li>
                    <li>Added aditional info to payment create</li>
                </ul>
                <h3>v 2.2.532.102</h3>
                <ul>
                    <li>Fixed Trade Org Save</li>
                    <li>Added Logo and Background files view to Trade Org Edit Form</li>
                    <li>Added Merchant Regions Dict</li>
                    <li>Region in Outlet Form changed to Drop Down</li>
                </ul>
                <h3>v 2.2.532.101</h3>
                <ul>
                    <li>Added Region for Outlets</li>
                    <li>Added Logo and Background for Tradeorgs</li>
                </ul>
                <h3>v 2.2.532.100</h3>
                <ul>
                    <li>
                        Added channel columns and filters to Order, Merchant and Preorders
                        Workplaces
                    </li>
                </ul>
                <h3>v 2.2.532.99</h3>
                <ul>
                    <li>Added Reference Id parameter to bill.PaymentTransactionAdd procedure</li>
                </ul>
                <h3>v 2.2.532.98</h3>
                <ul>
                    <li>
                        Cheged Maximum Overdue to Uninterrupted overdue in OrderTab of Clients
                        Workplace
                    </li>
                    <li>
                        Changed Filter from Maximum Overdue to Uninterrupted overdue in Clients
                        Workplace
                    </li>
                    <li>Added new parameter to Payment Create function</li>
                </ul>
                <h3>v 2.2.532.97</h3>
                <ul>
                    <li>Changed payment create method</li>
                    <li>Fixed client collection status bugs</li>
                </ul>
                <h3>v 2.2.532.96</h3>
                <ul>
                    <li>Added filter by overdue days</li>
                    <li>Changed client collection status field editing rules</li>
                    <li>Added client collection status history visible rules</li>
                </ul>
                <h3>v 2.2.532.95</h3>
                <ul>
                    <li>
                        <a href="tariffgroups">TariffGroup</a>: Добавлена передача rowsCount для
                        корректной пагинации
                    </li>
                    <li>Обновлена версия react-toolkit</li>
                </ul>
                <h3>v 2.2.531.95</h3>
                <ul>
                    <li>Интеграционные тесты: Исправлен ручной запуск</li>
                </ul>
                <h3>v 2.2.530.95</h3>
                <ul>
                    <li>
                        Обновлена версия пакета <code>axios</code> до <code>^0.29.0</code>
                    </li>
                    <li>
                        Удален устаревший неиспользуемый пакет <code>@aspnet/signalr</code>
                    </li>
                    <li>
                        Удален неиспользуемый <code>notify.ts</code>
                    </li>
                </ul>
                <h3>v 2.2.529.95</h3>
                <ul>
                    <li>React-toolkit был обновлен до версии 1.1.5</li>
                </ul>
                <h3>v 2.2.528.95</h3>{' '}
                <ul>
                    <li>Fixed Block sizes in Order Card</li>
                    <li>Fixed translation of DateTime inputs</li>
                </ul>
                <h3>v 2.2.528.94</h3>
                <ul>
                    <li>Added client collection status to Client card</li>
                    <li>Added client collection status history to Clients WP</li>
                </ul>
                <h3>v 2.2.528.93</h3>
                <ul>
                    <li>Updated react tooklit to 1.1.12</li>
                    <li>Fixed loans table height</li>
                </ul>
                <h3>v 2.2.528.92</h3>
                <ul>
                    <li>Fixed Culture param in Orders list query</li>
                    <li>Fixed Culture parameter in Preorders list query</li>
                    <li>Fixed Culture parameter in Merhcnat orders list query</li>
                </ul>
                <h3>v 2.2.528.91</h3>
                <ul>
                    <li>Fixed removing subsctiption on scroring finished notify</li>
                </ul>
                <h3>v 2.2.528.90</h3>
                <ul>
                    <li>
                        <code>columnFormatters</code>: Доработана типизация для{' '}
                        <code>dateTimeFormatter</code> и <code>phoneNumberFormatter</code>.
                        Исправлен баг когда при значении <code>null</code> падало приложение.
                    </li>
                </ul>
                <h3>v 2.2.527.90</h3>
                <ul>
                    <li>
                        Added save button check when client limit state is approved and products sum
                        more than limit amount
                    </li>
                </ul>
                <h3>v 2.2.527.89</h3>
                <ul>
                    <li>
                        Fixed merchant order create when user hasn&apos;t active trade orgs or
                        outlets
                    </li>
                </ul>
                <h3>v 2.2.527.88</h3>
                <ul>
                    <li>
                        Обновлена версия react-toolkit и исправлены ошибки при обновлении версии
                    </li>
                    <li>Доработаны компоненты для реализации нового дизайна</li>
                    <li>
                        Сформирован файл variables.scss с переменными scss и файл root.scss с
                        переменными css
                    </li>
                    <li>Стили сайдбара вынесены в переменные</li>
                    <li>Стили navMenu вынесены в переменные</li>
                    <li>Добавлены стандартные форматтеры для колонок таблиц</li>
                    <li>Добавлен словарь Designs с списком доступных версий дизайна</li>
                    <li>Добавлен метод на получение списка дизайнов</li>
                    <li>В сайдбар добавлен дропдаун для переключения дизайна</li>
                </ul>
                <h3>v 2.1.527.88</h3>
                <ul>
                    <li>
                        Лидогенераторы: Исправлен запрос, в котором приходили неправильные постбэки
                    </li>
                </ul>
                <h3>v 2.1.526.88</h3>
                <ul>
                    <li>
                        [PERU-198] РМ Лидогенераторы: Исправлен скрипт запроса если по критериям
                        фильтра нет ни одного постбека для лидгена
                    </li>
                </ul>
                <h3>v 2.1.525.88</h3>
                <ul>
                    <li>Changed user outlets request</li>
                </ul>
                <h3>v 2.1.524.88</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-30"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-30
                        </a>
                        ] Put logs into another database.
                    </li>
                </ul>
                <h3>v 2.1.523.88</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-1682"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-1682
                        </a>
                        ] Тип контента документа Excel для заголовка http ответа перенесен в базовый
                        контроллер
                    </li>
                </ul>
                <h3>v 2.1.522.88</h3>
                <ul>
                    <li>[BOF-174] Роли: Исправлена работа с рангами</li>
                </ul>
                <h3>v 2.1.521.88</h3>
                <ul>
                    <li>[BOF-95] Повышение ранга роли разработчика</li>
                </ul>
                <h3>v 2.1.520.88</h3>
                <ul>
                    <li>Fixed Order Loans Status Date</li>
                </ul>
                <h3>v 2.1.520.87</h3>
                <ul>
                    <li>Added client limit request button action in Merchant Order Form</li>
                    <li>Added saving rules for Merchant Order Form</li>
                </ul>
                <h3>v 2.1.520.86</h3>
                <ul>
                    <li>Added client limit visualization to Merchant order add form</li>
                    <li>Redisigned product list in Merchant order add form</li>
                    <li>Little order add form optimozations</li>
                </ul>
                <h3>v 2.1.520.85</h3>
                <ul>
                    <li>Added Source column and Filter by it in Order Workplace</li>
                    <li>Merchant, Preorder and Order code optimizations</li>
                </ul>
                <h3>v 2.1.520.84</h3>
                <ul>
                    <li>Fixed contract download in Merchant Workplace</li>
                </ul>
                <h3>v 2.1.520.83</h3>
                <ul>
                    <li>Added Repeat Client Approve Button to Order Workplace Modal</li>
                </ul>
                <h3>v 2.1.520.82</h3>
                <ul>
                    <li>Updated order select script for client manual payment form</li>
                    <li>
                        Added checking for active orders for displaying withdraw buttons near credit
                        cards
                    </li>
                </ul>
                <h3>v 2.1.520.81</h3>
                <ul>
                    <li>Fixed Client Withdraw Form</li>
                    <li>Updated react toolkit version</li>
                </ul>
                <h3>v 2.1.520.80</h3>
                <ul>
                    <li>Fixed order select list in client manual payment form</li>
                    <li>Fixed withdraw amount in client manual payment form</li>
                    <li>Added checking of max withdraw amount in client manual payment form</li>
                    <li>
                        Fixed error text of withdraw amount minimum limit in client manual payment
                        form
                    </li>
                    <li>
                        Added balance for transaction low balance error in client manual payment
                        form
                    </li>
                </ul>
                <h3>v 2.1.520.79</h3>
                <ul>
                    <li>Added Manual Payment from Card in Client Workplace</li>
                </ul>
                <h3>v 2.1.520.78</h3>
                <ul>
                    <li>Fixed UI in Order Workplace</li>
                </ul>
                <h3>v 2.1.520.77</h3>
                <ul>
                    <li>Added source column to Preorders Workplace Table</li>
                </ul>
                <h3>v 2.1.520.76</h3>
                <ul>
                    <li>[peru-105] РМ Лидогенераторы: Добавлено поле Базовый URL</li>
                </ul>
                <h3>v 2.1.519.76</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-1417"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-1417
                        </a>
                        ] Клиент для api LMS
                    </li>
                </ul>
                <h3>v 2.1.518.75</h3>{' '}
                <ul>
                    <li>Добавлен Дополнительный телефон в карточку клиента и его истории</li>
                </ul>
                <h3>v 2.1.518.75</h3>
                <ul>
                    <li>Исправлен тип OrderType в модели Заявок для удаления заявок</li>
                </ul>
                <h3>v 2.1.518.74</h3>
                <ul>
                    <li>Optimized Merchant Statistic sql script</li>
                </ul>
                <h3>v 2.1.518.73</h3>
                <ul>
                    <li>Fixed DynamicLists in Trade Orgs and Outlets Workplaces</li>
                    <li>
                        Fixed disable conditions for inputs of Trade Orgs and Outlets Workplaces
                    </li>
                </ul>
                <h3>v 2.1.517.73</h3>
                <ul>
                    <li>
                        Логирование: CancellationToken исключен из сериализации аргументов действий
                    </li>
                </ul>
                <h3>v 2.1.516.73</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-1503"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-1503
                        </a>
                        ,{' '}
                        <a href="https://gl-1.2pp.dev/paylater/paylater-back-office/-/issues/136">
                            136
                        </a>
                        ] Отображение типа ответа api в Swagger
                    </li>
                </ul>
                <h3>v 2.1.515.73</h3>
                <ul>
                    <li>Deleted start of billing job</li>
                </ul>
                <h3>v 2.0.515.72</h3>
                <ul>
                    <li>Restored fix from update 2.1.512.70</li>
                </ul>
                <h3>v 2.0.515.71</h3>
                <ul>
                    <li>Added column &apos;Source&apos; and filter to Workplace Merchant</li>
                    <li>Fixed Roles Queries for Workplace Merchant</li>
                </ul>
                <h3>v 2.1.515.70</h3>
                <ul>
                    <li>Удален Мерчант из main/dev</li>
                </ul>
                <h3>v 2.1.514.70</h3>
                <ul>
                    <li>Интеграционные тесты: Исправление инициализации</li>
                </ul>
                <h3>v 2.1.513.70</h3>
                <ul>
                    <li>Обновление @finbeat/react-toolkit до v0.2.2</li>
                </ul>
                <h3>v 2.1.512.70</h3>
                <ul>
                    <li>
                        Исправлен выбор документа для скачивания по выбранному языку у пользователя
                        в карточке РМ &quot;Мерчанта&quot;
                    </li>
                </ul>
                <h3>v 2.1.511.70</h3>
                <ul>
                    <li>
                        Логи действий пользователя: Записываются все параметры методов контроллеров
                    </li>
                </ul>
                <h3>v 2.1.510.70</h3>
                <ul>
                    <li>Обновление react-toolkit с 0.2.0 дo 0.2.1</li>
                </ul>
                <h3>v 2.1.509.70</h3>
                <ul>
                    <li>Добавлено время для дат в фильтр РМ &quot;Мерчанта&quot;</li>
                </ul>
                <h3>v 2.1.508.70</h3>
                <ul>
                    <li>Изменение условия действия кнопки &quot;Товар выгружен&quot;</li>
                </ul>
                <h3>v 2.1.507.70</h3>
                <ul>
                    <li>Enhance GetOptions to support custom emptyNode display</li>
                </ul>
                <h3>v 2.1.506.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-1330"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-1330
                        </a>
                        ] UI-Компонент ячейки таблицы для вывода заголовка и даты
                    </li>
                </ul>
                <h3>v 2.1.505.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-1250"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-1250
                        </a>
                        ] Рефакторинг и исправление ошибок при создании и изменении роли
                    </li>
                </ul>
                <h3>v 2.1.504.70</h3>
                <ul>
                    <li>Аутентификация: Исправлены ошибки аутентификации</li>
                </ul>
                <h3>v 2.1.503.70</h3>
                <ul>
                    <li>Обновление react-toolkit с 0.1.1 дo 0.1.3</li>
                </ul>
                <h3>v 2.1.502.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-157"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-1250
                        </a>
                        ] Исправление списка подролей (роли отображались как активированные, хотя на
                        самом деле было не так) модального окна ролей.
                    </li>
                </ul>
                <h3>v 2.1.501.70</h3>
                <ul>
                    <li>добавлена опция проверки и обновления security stamp при входе</li>
                </ul>
                <h3>v 2.1.500.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-172"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-172
                        </a>
                        ] Исправлено отображение скролбара для некоторых модальных окон
                    </li>
                </ul>
                <h3>v 2.1.499.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-411"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-411
                        </a>
                        ] Разработан api-интерфейс для работы с настройками инстанса
                    </li>
                </ul>
                <h3>v 2.1.498.70</h3>
                <ul>
                    <li>Обновление finbeat/react-toolkit до версии 0.1.1</li>
                </ul>
                <h3>v 2.1.497.70</h3>
                <ul>
                    <li>Перенесена реализация эксель парсера из таск сервиса</li>
                    <li>
                        В информацию об ошибке <code>ExcelParseErrorDto</code> добавлен номер
                        колонки в которой возникла ошибка
                    </li>
                    <li>
                        Добавлен отдельный метод <code>ParseHeaders&lt;T&gt;</code> для парсинга
                        заголовков таблицы по модели
                    </li>
                    <li>
                        Добавлен метод <code>FormatExcel</code> для изменения эксель файла
                    </li>
                </ul>
                <h3>v 2.1.496.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/IND-976"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            IND-976
                        </a>
                        ] Оптимизирован запрос на получение смс логов для экспорта в excel: удалены
                        параметры смс
                    </li>
                </ul>
                <h3>v 2.1.495.70</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-166"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-166
                        </a>
                        ] Исправление фильрации списка ролей для модального окна ролей
                    </li>
                </ul>
                <h3>v 2.1.494.70</h3>
                <ul>
                    <li>Переработан отчет Reconciliation</li>
                </ul>
                <h3>v 2.1.494.69</h3>
                <ul>
                    <li>Исправлено получение списка отчетов</li>
                </ul>
                <h3>v 2.1.494.68</h3>
                <ul>
                    <li>Удаление неактуальных ролей</li>
                </ul>
                <h3>v 2.1.494.67</h3>
                <ul>
                    <li>РМ Клиенты: Исправление перехода в выбранную заявку</li>
                </ul>
                <h3>v 2.1.494.66</h3>
                <ul>
                    <li>
                        [g-186] Добавление поддержки применения изменений ролевых пропсов в рилтайм
                        режиме (без перелогина)
                    </li>
                </ul>
                <h3>v 2.1.493.66</h3>
                <ul>
                    <li>
                        Добавлено время для &quot;даты начала&quot; и &quot;даты окончания&quot; в
                        фильтр Предзаявок
                    </li>
                </ul>
                <h3>v 2.1.493.65</h3>
                <ul>
                    <li>Изменён типа поля FlexFinID в карточке Заявки</li>
                </ul>
                <h3>v 2.1.493.64</h3>
                <ul>
                    <li>Добавлена фильтрация типов отчетов по ролям</li>
                </ul>
                <h3>v 2.1.493.63</h3>
                <ul>
                    <li>[b-18942] CRM: Из виджета убран токен</li>
                </ul>
                <h3>v 2.1.493.62</h3>
                <ul>
                    <li>Сделан выбор по умолчанию Узбекского языка</li>
                </ul>
                <h3>v 2.1.493.61</h3>
                <ul>
                    <li>Исправлен статус редактирования FlexFinId в заявке</li>
                </ul>
                <h3>v 2.1.493.60</h3>
                <ul>
                    <li>Исправлено сохранение FlexFinID</li>
                </ul>
                <h3>v 2.1.493.59</h3>
                <ul>
                    <li>
                        Исправлено отображение кнопок загрузки и скачивания в карточке Предзаявки в
                        ЛК Мерчанта
                    </li>
                </ul>
                <h3>v 2.1.492.59</h3>
                <ul>
                    <li>[b-18942] Аутентификация: Настройки куки для Перу</li>
                </ul>
                <h3>v 2.1.491.59</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-157"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-157
                        </a>
                        ] Исправлена ошибка отображение имен роли в модальном окне роли
                    </li>
                </ul>
                <h3>v 2.1.490.59</h3>
                <ul>
                    <li>Обновлена инициализация языков</li>
                </ul>
                <h3>v 2.1.489.59</h3>
                <ul>
                    <li>Добавлена переменная @pLang в процедуру отправки СМС</li>
                </ul>
                <h3>v 2.1.488.59</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-157"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-157
                        </a>
                        ] Обновленный UI для вкладки ролей модального окна РМ &quot;Роли&quot;
                    </li>
                </ul>
                <h3>v 2.1.487.59</h3>
                <ul>
                    <li>
                        исправление кодов и наименований словарей для стартовой страницы
                        пользователей по ролям
                    </li>
                </ul>
                <h3>v 2.1.486.59</h3>
                <ul>
                    <li>
                        [
                        <a href="https://gl-1.2pp.dev/paylater/paylater-back-office/-/merge_requests/1777">
                            BOF-155
                        </a>
                        ] Удалена работа с адресами из главной ветки
                    </li>
                </ul>
                <h3>v 2.1.485.59</h3>
                <ul>
                    <li>Исправлена ошибка при открытии карточки ТО и ТТ</li>
                </ul>
                <h3>v 2.1.484.59</h3>
                <ul>
                    <li>Добавлена форма ввода FlexFinId в карточке Заявки</li>
                </ul>
                <h3>v 2.1.484.58</h3>
                <ul>
                    <li>
                        Сделана привязка к роли редактирования в карточке Клиента РМ
                        &quot;Клиенты&quot;
                    </li>
                </ul>
                <h3>v 2.1.484.57</h3>
                <ul>
                    <li>
                        <a href="https://jira.2pp.dev/browse/BOF-151">BOF-151</a> Переделано
                        отображение карт в карточке клиента и заявок
                    </li>
                </ul>
                <h3>v 2.1.484.56</h3>
                <ul>
                    <li>
                        Исправлена пагинация в РМ &quot;Торговые организации&quot; и РМ
                        &quot;Торговые точки&quot;
                    </li>
                </ul>
                <h3>v 2.1.483.56</h3>
                <ul>
                    <li>Исправлено отображение данных по клиенту в РМ &quot;Мерчанта&quot;</li>
                </ul>
                <h3>v 2.1.482.56</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-152"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-152
                        </a>
                        ] Исправлено падение приложения при открытии модального окна добавления
                        новой записи в таблицу наборов параметров для процедур
                    </li>
                </ul>
                <h3>v 2.1.481.56</h3>
                <ul>
                    <li>
                        [
                        <a
                            href="https://jira.2pp.dev/browse/BOF-148"
                            rel="nofollow noreferrer noopener"
                            target="_blank"
                        >
                            BOF-148
                        </a>
                        ] Исправление сортировки по колонкам &quot;Type&quot; и &quot;Name&quot; РМ
                        Ролей
                    </li>
                </ul>
                <h3>v 2.1.480.56</h3>
                <ul>
                    <li>[BOF-15] - стартовая страница по роли пользователя</li>
                </ul>
                <h3>v 2.1.479.56</h3>
                <ul>
                    <li>[b-18942] Аутентификация: Настройки куки для прода Колумбии</li>
                </ul>
                <h3>v 2.1.478.56</h3>
                <ul>
                    <li>Исправлено отображение данных клиента в РМ &quot;Предзаявки&quot;</li>
                </ul>
                <h3>v 2.1.478.55</h3>
                <ul>
                    <li>Сделано агрегирование данных по РМ &quot;Мерчант&quot;</li>
                </ul>
                <h3>v 2.1.477.55</h3>
                <ul>
                    <li>
                        [<a href="https://jira.2pp.dev/browse/IND-249">IND-249</a>] Исправлена
                        полоса прокрутки в РМ настройки рабочих мест.
                    </li>
                </ul>
                <h3>v 2.1.476.55</h3>
                <ul>
                    <li>Сделано агрегирование данных по РМ &quot;Предзаявки&quot;</li>
                </ul>
                <h3>v 2.1.476.54</h3>
                <ul>
                    <li>Исправлен фильтр по ТО и ТТ в РМ &quot;Заявки&quot;</li>
                </ul>
                <h3>v 2.1.476.53</h3>
                <ul>
                    <li>Исправлен скрипт получения контактов для РМ &quot;Мерчант&quot;</li>
                </ul>
                <h3>v 2.1.475.53</h3>
                <ul>
                    <li>
                        В РМ &quot;Заявки&quot; добавлена фильтры по Торговым организациям и
                        Торговым точкам и колонку Мерчант
                    </li>
                    <li>В РМ &quot;Предзаявки&quot; переименована колонку</li>
                </ul>
                <h3>v 2.1.475.52</h3>
                <ul>
                    <li>Исправлено отображение контактов в РМ &quot;Мерчант&quot;</li>
                    <li>Исправлено получение доступных тарифных групп в РМ &quot;Мерчант</li>
                </ul>
                <h3>v 2.1.474.52</h3>
                <ul>
                    <li>Изменил стартовую дату в РМ &quot;Мечанта&quot;</li>
                </ul>
                <h3>v 2.1.473.52</h3>
                <ul>
                    <li>
                        В РМ &quot;Тарифные группы&quot; добавлены условия отображения поля IsBase в
                        тарифах
                    </li>
                    <li>
                        В РМ &quot;Тарифные группы&quot; при сохранении добавлена проверка, при
                        которой IsBase = true, если был выбран только один тариф
                    </li>
                    <li>
                        В РМ &quot;Тарифные группы&quot; Исправлен баг, при котором во время
                        создания новой ТГ сохранялись удаленные тарифы
                    </li>
                </ul>
                <h3>v 2.1.472.52</h3>
                <ul>
                    <li>
                        Добавлена возможность передавать массив искомых значений заголовков для
                        кастомного атрибута
                    </li>
                </ul>
                <h3>v 2.1.471.52</h3>
                <ul>
                    <li>Изменена стартовая дата для РМ &quot;Заявки&quot; (7 дней назад)</li>
                    <li>Изменена стартовая дата для РМ &quot;Предзаявки&quot; (7 дней назад)</li>
                </ul>
                <h3>v 2.1.471.51</h3>
                <ul>
                    <li>
                        Исправлена ошибка маски банковской карты, при которой вылетал белый экран
                    </li>
                </ul>
                <h3>v 2.1.471.50</h3>
                <ul>
                    <li>Сделана маскировка банковской карты в карточке клиента</li>
                </ul>
                <h3>v 2.1.471.49</h3>
                <ul>
                    <li>Исправлен баг с табом платежей в Карточке клиента</li>
                </ul>
                <h3>v 2.1.471.48</h3>
                <ul>
                    <li>Перенес раздел клиенты на уровень выше в сайдбаре</li>
                </ul>
                <h3>v 2.1.471.47</h3>
                <ul>
                    <li>[BOF-109] Добавление ссылки на инструкцию Мерчанта</li>
                </ul>
                <h3>v 2.1.470.47</h3>
                <ul>
                    <li>Исправлена сортировка по колонке Parameters в РМ &quot;Логи СМС&quot;</li>
                </ul>
                <h3>v 2.1.469.47</h3>
                <ul>
                    <li>
                        [<a href="https://jira.2pp.dev/browse/IND-249">IND-249</a>] Исправление
                        стилей для различных таблиц
                    </li>
                </ul>
                <h3>v 2.1.468.47</h3>
                <ul>
                    <li>
                        Исправлена ошибка с дублированием колонки &quot;Сумма покрытия&quot; в
                        таблице начислений
                    </li>
                </ul>
                <h3>v 2.1.468.46</h3>
                <ul>
                    <li>Добавлен список продуктов в карточку РМ &quot;Заявки&quot;</li>
                </ul>
                <h3>v 2.1.468.45</h3>
                <ul>
                    <li>Исправление сортировки таблицы детализации отчета</li>
                </ul>
                <h3>v 2.1.468.44</h3>
                <ul>
                    <li>
                        Исправлено отображение группы тарифов в карточке Мерчанта, если она стала
                        недоступна для выбора
                    </li>
                </ul>
                <h3>v 2.1.467.44</h3>
                <ul>
                    <li>исправление сохранения пропсов в группах тарифов</li>
                </ul>
                <h3>v 2.1.466.44</h3>
                <ul>
                    <li>Исправлено изменение у пользователя ТО и ТТ</li>
                </ul>
                <h3>v 2.1.465.44</h3>
                <ul>
                    <li>
                        Исправлен выбор кредитного продукта при создании/редактировании тарифной
                        группы. Неактивные продукты теперь не отображаются в выборе
                    </li>
                </ul>
                <h3>v 2.1.464.44</h3>
                <ul>
                    <li>
                        Исправлена фокусировка на РМ &quot;Мерчанта&quot; в сайдбаре при
                        перезагрузке страницы
                    </li>
                </ul>
                <h3>v 2.1.463.44</h3>
                <ul>
                    <li>
                        <a href="https://jira.2pp.dev/browse/BOF-7">[BOF-6]</a>: Переход на NPM
                        пакеты наших компонентов
                    </li>
                </ul>
                <h3>v 2.0.463.44</h3>
                <ul>
                    <li>
                        <a href="https://jira.2pp.dev/browse/BOF-103">BOF-103</a>: Исправлены
                        всплывающие сообщения, переработана логика их автоудаления
                    </li>
                </ul>
                <h3>v 2.0.462.44</h3>
                <ul>
                    <li>Исправлено отображение списка в РМ &quot;Предзаявки&quot;</li>
                    <li>Исправлено выставление дефолтного фильтра в РМ &quot;Предзаявки&quot;</li>
                </ul>
                <h3>v 2.0.462.43</h3>
                <ul>
                    <li>
                        Исправлена фокусировка в сайдбаре на РМ &quot;Предзаявки&quot; при
                        перезагрузки страницы
                    </li>
                </ul>
                <h3>v 2.0.462.42</h3>
                <ul>
                    <li>Добавлено отображение заявок в статусе Преордер по умолчанию</li>
                    <li>Исправлена фильтрация по статусам</li>
                </ul>
                <h3>v 2.0.462.41</h3>
                <ul>
                    <li>Исправление ошибки при выборе ТТ в фильтре</li>
                    <li>Исправлено отображение грида в РМ &quot;Предзаявки&quot; по статусам</li>
                    <li>Исправлено отображение статусов в гриде в РМ &quot;Предзаявки&quot;</li>
                    <li>Исправлен фильтр в гриде в РМ &quot;Предзаявки&quot;</li>
                </ul>
                <h3>v 2.0.462.40</h3>
                <ul>
                    <li>
                        добавлен дополнительный универсальный параметр AdditionalInfo для ответа
                        загрузки файла
                    </li>
                </ul>
                <h3>v 2.0.461.40</h3>
                <ul>
                    <li>
                        Добавлен кастомный атрибут для парсинга колонок с возможностью указать
                        подстроку для поиска, обязательность колонки и уникальность
                    </li>
                    <li>Доработан вывод ошибок при парсинге</li>
                    <li>Добавлена передача атрибута dateOnly в PropValidatedValueInput</li>
                    <li>
                        Исправлен баг BaseValidatedDatePicker когда значение внутри него не
                        обновлялось при изменении через setValue из контекста формы
                    </li>
                </ul>
                <h3>v 2.0.460.40</h3>
                <ul>
                    <li>
                        <a href="https://jira.2pp.dev/browse/BOF-105">BOF-105</a> исправление сброса
                        сортировки при переходе по страницам в DataGrid
                    </li>
                </ul>
                <h3>v 2.0.459.40</h3>
                <ul>
                    <li>Исправление падения приложения при введении некорректной даты</li>
                </ul>
                <h3>v 2.0.458.40</h3>
                <ul>
                    <li>Добавлено новое РМ &quot;Предзаявки&quot;</li>
                </ul>
                <h3>v 2.0.458.39</h3>
                <ul>
                    <li>
                        Исправлено получение параметра <code>CRMHealthUrl</code> из настроек
                    </li>
                </ul>
                <h3>v 2.0.457.39</h3>
                <ul>
                    <li>
                        <a href="smslog">РМ &quot;Логи СМС&quot;</a>: исправлена пагинация в таблице
                    </li>
                </ul>
                <h3>v 2.0.456.39</h3>
                <ul>
                    <li>Исправлено формирование ссылки на восстановление пароля</li>
                </ul>
                <h3>v 2.0.455.39</h3>
                <ul>
                    <li>Исправление применения фильтра смс логов</li>
                </ul>
                <h3>v 2.0.454.39</h3>
                <ul>
                    <li>
                        Поддержка параметра &quot;step&quot; для <code>input</code> с типом{' '}
                        <code>number</code>
                    </li>
                </ul>
                <h3>v 2.0.453.39</h3>
                <ul>
                    <li>
                        Исправлена ошибка, когда у компонента DatePicker не работала возможность
                        выбирать только время или только дату
                    </li>
                </ul>
                <h3>v 2.0.452.39</h3>
                <ul>
                    <li>РМ Пользователи: Загрузка файлом</li>
                </ul>
                <h3>v 2.0.451.39</h3>
                <ul>
                    <li>BaseEditablePopoverInput: Обновление значений зависимых полей</li>
                </ul>
                <h3>v 2.0.450.39</h3>
                <ul>
                    <li>
                        В BaseDataGrid исправлен баг когда при передаче lineHeight изменялась в том
                        числе высота заголовков
                    </li>
                </ul>
                <h3>v 2.0.449.39</h3>
                <ul>
                    <li>Исправлен баг с отображением датапикера в BaseEditablePopoverInput</li>
                    <li>Добавлена передача свойства disabled в wrapper BaseDynamicList</li>
                    <li>Исправлен стиль иконок в сайдбаре</li>
                    <li>
                        Добавлен класс <code>content-right</code>
                    </li>
                </ul>
                <h3>v 2.0.448.39</h3>
                <ul>
                    <li>Исправление истории в карточке клиента</li>
                    <li>Исправление адреса</li>
                </ul>
                <h3>v 2.0.448.38</h3>
                <ul>
                    <li>
                        В Карточку клиента добавлены поля &quot;ПИНФЛ&quot;, &quot;Дата выдачи
                        паспорта&quot;, &quot;Кем выдан&quot;
                    </li>
                    <li>Добавлен Узбекский перевод значениям для Поля &quot;Пол&quot;</li>
                    <li>
                        В Карточке клиента убраны поля &quot;Вторая фамилия&quot; и
                        &quot;Почта&quot;
                    </li>
                    <li>В Файлах клиента убраны блоки &quot;Удостоверение личности&quot;</li>
                </ul>
                <h3>v 2.0.448.37</h3>
                <ul>
                    <li>Добавлена возможность сброса пароля</li>
                </ul>
                <h3>v 2.0.447.37</h3>
                <ul>
                    <li>Исправление ошибки дублирования &apos;desc&apos; в запросах sql</li>
                </ul>
                <h3>v 2.0.446.37</h3>
                <ul>
                    <li>
                        Пропсы с типом &quot;phone&quot; отображаются с маской телефона и
                        проверяются на формат
                    </li>
                </ul>
                <h3>v 2.0.445.37</h3>
                <ul>
                    <li>
                        РМ Пользователи: Исправлен баг с созданием и изменением пользователя без
                        торговых точек
                    </li>
                </ul>
                <h3>v 2.0.444.37</h3>
                <ul>
                    <li>Аутентификация: Исправлено перенаправление со страницы входа в систему</li>
                </ul>
                <h3>v 2.0.443.37</h3>
                <ul>
                    <li>[b-18942] Аутентификация: Исправлены куки для LocalColTest</li>
                </ul>
                <h3>v 2.0.442.37</h3>
                <ul>
                    <li>Аутентификация: Удален метод API для аутентификации в CRM</li>
                </ul>
                <h3>v 2.0.441.37</h3>
                <ul>
                    <li>
                        Исправление ошибки приложения при отображении таблиц в некоторых случаях.
                    </li>
                </ul>
                <h3>v 2.0.440.37</h3>
                <ul>
                    <li>РМ Пользователи: Исправлены операции создания и изменения пользователя</li>
                </ul>
                <h3>v 2.0.439.37</h3>
                <ul>
                    <li>Добавлена конечная точка для получения времени</li>
                </ul>
                <h3>v 2.0.438.37</h3>
                <ul>
                    <li>Исправление фильтрации заявок через меню</li>
                </ul>
                <h3>v 2.0.438.36</h3>
                <ul>
                    <li>Обновление таблицы при изменении параметров урл</li>
                </ul>
                <h3>v 2.0.437.36</h3>
                <ul>
                    <li>
                        РМ Лидогенераторы: Исправлена строка фильтрации: Добавлено значение Показать
                        неактивные
                    </li>
                </ul>
                <h3>v 2.0.436.36</h3>
                <ul>
                    <li>Исправление параметров фильтрации таблиц в урл</li>
                </ul>
                <h3>v 2.0.435.36</h3>
                <ul>
                    <li>
                        Добавлен клайм PortalUserEmployerId с информацией о привязанном к
                        пользователю работодателе
                    </li>
                    <li>Добавлен вызов апи для /accounts/password</li>
                    <li>Добавлено отдельное меню для ЛК Работодателя в сайдбаре</li>
                    <li>Добавлено правило валидации для пароля</li>
                    <li>
                        Добавлена возможность фильтрации по ролям при получении элементов для
                        выпадающего списка
                    </li>
                </ul>
                <h3>v 2.0.434.36</h3>
                <ul>
                    <li>Авторизация: Конфигурации для домена кук авторизации</li>
                </ul>
                <h3>v 2.0.433.36</h3>
                <ul>
                    <li>
                        РМ &quot;SMSLogs&quot; добавлена колонка для отображение параметров шаблона
                    </li>
                </ul>
                <h3>v 2.0.432.36</h3>
                <ul>
                    <li>Добавлено отображение номера карты в карточке клиента</li>
                </ul>
                <h3>v 2.0.432.35</h3>
                <ul>
                    <li>Исправлена сортировка по идентификатору в РМ Мерчандайзера</li>
                </ul>
                <h3>v 2.0.431.35</h3>
                <ul>
                    <li>Исправление работы фильтра таблиц</li>
                </ul>
                <h3>v 2.0.430.35</h3>
                <ul>
                    <li>Исправлено применение фильтра для РМ &quot;Клиенты&quot;</li>
                </ul>
                <h3>v 2.0.429.35</h3>
                <ul>
                    <li>
                        Исправлена ошибка, при которой в фильтре РМ Заявки не отображались статусы
                        заявок
                    </li>
                    <li>Убрал ненужную колонку сортировки в РМ Заявки</li>
                </ul>
                <h3>v 2.0.429.34</h3>
                <ul>
                    <li>Авторизация: Исправлена переадресация в CRM</li>
                </ul>
                <h3>v 2.0.428.34</h3>
                <ul>
                    <li>Исправление сортировки таблиц по убыванию</li>
                </ul>
                <h3>v 2.0.427.34</h3>
                <ul>
                    <li>Исправление перекрытия компонента выбора даты</li>
                </ul>
                <h3>v 2.0.426.34</h3>
                <ul>
                    <li>
                        Авторизация: Добавлена переадресация на переадресацию в CRM при
                        переадресации на страницу логина при переадресации на CRM при невалидных
                        токенах
                    </li>
                </ul>
                <h3>v 2.0.425.34</h3>
                <ul>
                    <li>Исправлено получение платежей, когда ReferenceId равен null</li>
                </ul>
                <h3>v 2.0.425.33</h3>
                <ul>
                    <li>Исправлено получение списка займов</li>
                </ul>
                <h3>v 2.0.425.32</h3>
                <ul>
                    <li>Исправлена сортировка таблиц</li>
                </ul>
                <h3>v 2.0.424.32</h3>
                <ul>
                    <li>
                        Авторизация: Получение адреса из URL и переадресация на него при
                        переадресации в CRM
                    </li>
                </ul>
                <h3>v 2.0.423.32</h3>
                <ul>
                    <li>РМ Пользователи: Добавлена подсказка для поля Внешний пользователь</li>
                </ul>
                <h3>v 2.0.422.32</h3>
                <ul>
                    <li>Рефакторин параметров фильтрации данных в таблицах в строке урл</li>
                </ul>
                <h3>v 2.0.421.32</h3>
                <ul>
                    <li>РМ Пользователи: Добавлен флаг Внешний пользователь</li>
                </ul>
                <h3>v 2.0.420.32</h3>
                <ul>
                    <li>Возможность удаления значения из компонента выбора даты и времени</li>
                </ul>
                <h3>v 2.0.419.32</h3>
                <ul>
                    <li>Исправлен выбора статуса в фильтре в ЛК Мерчандайзера</li>
                </ul>
                <h3>v 2.0.418.32</h3>
                <ul>
                    <li>Скрипт обновления категории товаров</li>
                </ul>
                <h3>v 2.0.417.32</h3>
                <ul>
                    <li>Авторизация: Исправлено получение UserId при обновлении токена</li>
                </ul>
                <h3>v 2.0.416.32</h3>
                <ul>
                    <li>Исправлена загрузка подписанного контракта</li>
                </ul>
                <h3>v 2.0.416.31</h3>
                <ul>
                    <li>Изменено получение статусов ТО в ЛК Мерчандайзера</li>
                </ul>
                <h3>v 2.0.415.31</h3>
                <ul>
                    <li>Авторизация: Исправлена проверка времени токена обновления</li>
                </ul>
                <h3>v 2.0.414.31</h3>
                <ul>
                    <li>Скрипт обновления статусов ТО для Узбекистана</li>
                </ul>
                <h3>v 2.0.414.30</h3>
                <ul>
                    <li>Авторизация: В куках AccessToken убрана настройка SameSite</li>
                </ul>
                <h3>v 2.0.413.30</h3>
                <ul>
                    <li>
                        ЛК Мерчандайзера: Исправлено отображение суммы продаж в статистике
                        пользователя
                    </li>
                    <li>
                        ЛК Мерчандайзера: Убрано условие для доступности кнопки &quot;Товар
                        выдан&quot;. Теперь сгенерированный договор не обязателен для активации
                        кнопки
                    </li>
                </ul>
                <h3>v 2.0.412.30</h3>
                <ul>
                    <li>
                        Добавлена минимальная высота инпута для ситуации когда инпут не заполнен
                    </li>
                </ul>
                <h3>v 2.0.411.30</h3>
                <ul>
                    <li>
                        Авторизация в CRM: Переадресация на страницу логина при попытке
                        неавторизованного доступа
                    </li>
                    <li>Авторизация в CRM: Детализация исключения при обращении к API CRM</li>
                </ul>
                <h3>v 2.0.410.30</h3>
                <ul>
                    <li>Авторизация: Изменены url для crm на тесте Колумбии</li>
                </ul>
                <h3>v 2.0.409.30</h3>
                <ul>
                    <li>РМ Роли: Добавлен атрибут Техническая роль</li>
                </ul>
                <h3>v 2.0.408.30</h3>
                <ul>
                    <li>ЛК Заявки: В получение документов заявки добавлен подписанный контракт</li>
                    <li>ЛК Заявки: Исправление отображаемой информации по займам</li>
                </ul>
                <h3>v 2.0.408.29</h3>
                <ul>
                    <li>Исправление запроса на получение информации по биллингу</li>
                </ul>
                <h3>v 2.0.408.28</h3>
                <ul>
                    <li>Исправлено отображение Суммы долга и суммы для погашения в заявке</li>
                </ul>
                <h3>v 2.0.408.27</h3>
                <ul>
                    <li>Исправлена ошибка при создании и редактировании группы тарифов</li>
                </ul>
                <h3>v 2.0.407.27</h3>
                <ul>
                    <li>Исправлена ссылка на скачивание контракта</li>
                </ul>
                <h3>v 2.0.406.27</h3>
                <ul>
                    <li>Исправлено отображение данных клиента</li>
                    <li>Изменена маска Номер документа у клиента</li>
                    <li>У Клиента В Номере документа сделано отображение паспорта</li>
                    <li>Поле &quot;Второе имя&quot; было переименовано в &quot;Отчество&quot;</li>
                    <li>В поле Адреса теперь отображается адрес постоянной регистрации</li>
                </ul>
                <h3>v 2.0.406.26</h3>
                <ul>
                    <li>Настройка CRM для production</li>
                </ul>
                <h3>v 2.0.406.25</h3>
                <ul>
                    <li>Добавлено разделение на Владельца ТО и Продавца в ЛК Мерчанта</li>
                    <li>Исправлен запрос статистики по продажам в ЛК Мерчанта</li>
                    <li>
                        Исправлен скрипт обновления БД, при котором добавлялось две одинаковых
                        настройки
                    </li>
                    <li>Улучшено отображение селфи пользователя в ЛК Мерчанта</li>
                    <li>Исправлена загрузка файлов контрактов в ЛК Мерчанта</li>
                    <li>Исправлены сортировки в гриде ЛК Мерчанта</li>
                </ul>
                <h3>v 2.0.405.25</h3>
                <ul>
                    <li>Авторизация: Исправлена обработка ошибок от crm</li>
                </ul>
                <h3>v 2.0.404.25</h3>
                <ul>
                    <li>Добавлены URL для CRM</li>
                </ul>
                <h3>v 2.0.403..25</h3>
                <ul>
                    <li>Товар выдан работает теперь как надо</li>
                    <li>Выбранный тариф теперь отображается корректно</li>
                    <li>
                        Добавил проверку максимальных сумм. При превышения ограничений на
                        максимальные суммы, будет высвечиваться оповещение
                    </li>
                    <li>Расчет тарифа выводит ближайший платеж, а не последний</li>
                    <li>Добавлено увеличение селфи при наведении на него мышью</li>
                    <li>Расширены допустимые форматы для загрузки подписанного контакта</li>
                </ul>
                <h3>v 2.0.402.25</h3>
                <ul>
                    <li>
                        Добавлена возможность проверки минимального размера номера телефона по его
                        маске
                    </li>
                </ul>
                <h3>v 2.0.401.25</h3>
                <ul>
                    <li>Аутентификация: Метод АПИ для аутентификации в CRM</li>
                </ul>
                <h3>v 2.0.400.25</h3>
                <ul>
                    <li>Удалены устаревшие скрипты</li>
                    <li>
                        Добавлен владелец кода для файла <code>.gitlab-ci.yaml</code>
                    </li>
                    <li>
                        Исправлена ошибка, когда при добавлении заголовка в файлы ядра
                        использовалась неверная кодировка
                    </li>
                    <li>
                        Исправлена ошибка, когда хук блокировки изменения файлов ядра не выполнялся
                    </li>
                    <li>
                        Обновлены версии <code>husky</code>, <code>csharpier</code> и{' '}
                        <code>jetbrains.resharper.globaltools</code>
                    </li>
                </ul>
                <h3>v 2.0.399.25</h3>
                <ul>
                    <li>ЛК Мерчанта: Добавлена генерация хеша для подписанного документа</li>
                    <li>
                        ЛК Мерчанта: Исправление, при котором даже при удачно загруженном контракте
                        выдавалась ошибка
                    </li>
                    <li>
                        ЛК Мерчанта: Исправление отображения сообщения подтверждения выдачи товара
                    </li>
                    <li>Исправлено отображение ApiSettings в ТО и ТТ</li>
                </ul>
                <h3>v 2.0.398.25</h3>
                <ul>
                    <li>РМ Пользователи: Выбирать торговые точки по торговым организациям</li>
                </ul>
                <h3>v 2.0.397.25</h3>
                <ul>
                    <li>Исправлено использование BaseValidatedDynamicList</li>
                </ul>
                <h3>v 2.0.397.24</h3>
                <ul>
                    <li>Откатил откат рефакторинга BaseDynamicList</li>
                    <li>Исправлено использование BaseValidatedDynamicList</li>
                </ul>
                <h3>v 2.0.396.24</h3>
                <ul>
                    <li>Поправлено сохранение заявки</li>
                    <li>Добавлено скачивание договора и загрузка скана</li>
                    <li>Добавлена подгрузка селфи</li>
                    <li>Добавлена кнопка выдачи товара</li>
                    <li>Мелкие исправления интерфейса</li>
                </ul>
                <h3>v 2.0.395.24</h3>
                <ul>
                    <li>Исправлен доступ к сервисам при создании нового тарифа</li>
                </ul>
                <h3>v 2.0.395.23</h3>
                <ul>
                    <li>Откатил доработки по BaseDynamicList</li>
                </ul>
                <h3>v 2.0.394.23</h3>
                <ul>
                    <li>Исправлен запрос в модалке тарифов</li>
                </ul>
                <h3>v 2.0.394.22</h3>
                <ul>
                    <li>Исправлена маска телефона при редактировании данных пользователя</li>
                    <li>
                        Добавлена маска номера телефона в{' '}
                        <a href="users">РМ &quot;Пользователи&quot;</a>
                    </li>
                    <li>
                        Добавлено скрытие столбца <code>Actions</code> в{' '}
                        <a href="users">РМ &quot;Пользователи&quot;</a>, если у пользователя нет
                        доступа к каким-либо действиям
                    </li>
                </ul>
                <h3>v 2.0.393.22</h3>
                <ul>
                    <li>
                        Обновление ролей доступа к выгрузке Excel в{' '}
                        <a href="smslog">РМ &quot;Логи СМС&quot;</a>
                    </li>
                </ul>
                <h3>v 2.0.392.22</h3>
                <ul>
                    <li>смена логики отображения PropValidatedValueInput c типом number</li>
                    <li>изменение логики отображения модального окна РМ Группа тарифов</li>
                </ul>
                <h3>v 2.0.391.22</h3>
                <ul>
                    <li>В гриде РМ Заявки убраны столбцы ПРОДУКТ, ОПЕРАТОР</li>
                    <li>
                        В модальном окне Заявки убрана вкладка &quot;Проверки&quot;. Изменена
                        вкладка &quot;Клиенты&quot;
                    </li>
                    <li>Смена отображаемых статусов заявки в быстром фильтре и фильтре грида</li>
                    <li>
                        Скрыты разделы меню &quot;лидогенераторы&quot;, &quot;выплаты
                        клиентам&quot;, &quot;выгрузка реестров на перечисление&quot;
                    </li>
                </ul>
                <h3>v 2.0.391.21</h3>
                <ul>
                    <li>
                        Удален джоин к таблице loanRegistry в запросе на получение параметров займа
                    </li>
                </ul>
                <h3>v 2.0.391.20</h3>
                <ul>
                    <li>Добавление ЛК Мерчанта</li>
                    <li>Исправление обновления Торговых точек у пользователя</li>
                </ul>
                <h3>v 2.0.390.20</h3>
                <ul>
                    <li>Изменение невалидного адреса виджета CRM</li>
                </ul>
                <h3>v 2.0.390.19</h3>
                <ul>
                    <li>
                        Удалено свойство TradeOrgId из TariffGroup и исправлен функционал ТО и ТТ в
                        связи с этим изменением
                    </li>
                    <li>
                        Полностью удален раздел Тарифных Групп из РМ &quot;Торговые
                        организации&quot;
                    </li>
                    <li>Исправлено добавление ролей в скриптах обновления ТО и ТТ</li>
                </ul>
                <h3>v 2.0.389.19</h3>
                <ul>
                    <li>Ролям добавлен пропс RoleCanViewOrdersWithActiveProlongationAgreements</li>
                </ul>
                <h3>v 2.0.388.19</h3>
                <ul>
                    <li>Фикс сохранения тарифов в ТО</li>
                    <li>Доработка интерфейсов в ТО</li>
                    <li>Привязка полей к ролям в ТО и ТТ для их скрытия или отображения</li>
                </ul>
                <h3>v 2.0.387.19</h3>
                <ul>
                    <li>Рабочее место торговых точке: обработка клика по тексту чекбокса</li>
                </ul>
                <h3>v 2.0.386.19</h3>
                <ul>
                    <li>Интеграционные тесты: Рефакторинг</li>
                </ul>
                <h3>v 2.0.385.19</h3>
                <ul>
                    <li>РМ Лидогенераторы: Исправлена роль для кнопки отчета</li>
                </ul>
                <h3>v 2.0.385.18</h3>
                <ul>
                    <li>РМ &quot;Торговые точки&quot;</li>
                </ul>
                <h3>v 2.0.384.18</h3>
                <ul>
                    <li>Рабочее место &quot;Торговые точки&quot;</li>
                </ul>
                <h3>v 2.0.383.18</h3>
                <ul>
                    <li>Удалена директория для ручной загрузки платежей</li>
                </ul>
                <h3>v 2.0.382.18</h3>
                <ul>
                    <li>Добавлена директория для ручной загрузки платежей</li>
                </ul>
                <h3>v 2.0.381.18</h3>
                <ul>
                    <li>Конфиги для тест сервера</li>
                    <li>Конфиги для виджета CRM</li>
                </ul>
                <h3>v 2.0.381.17</h3>
                <ul>
                    <li>
                        <a href="/order">РМ Заявки</a>: В модалке заявки добавлено отображение
                        описания для статуса в истории статусов
                    </li>
                </ul>
                <h3>v 2.0.381.16</h3>
                <ul>
                    <li>Смена статус кода при создании пользователя в CRM</li>
                </ul>
                <h3>v 2.0.380.16</h3>
                <ul>
                    <li>Добавлено получение новых клаймов TradeOrgId и Outlets</li>
                </ul>
                <h3>v 2.0.379.16</h3>
                <ul>
                    <li>Реализован алгоритм обновления роли для CRM</li>
                </ul>
                <h3>v 2.0.378.16</h3>
                <ul>
                    <li>Исправлено отображение ФИО пользователя</li>
                    <li>Исправлен перевод BackOfficeIsTechnicalUser</li>
                </ul>
                <h3>v 2.0.377.16</h3>
                <ul>
                    <li>Исправлено условие обновления записи словаря</li>
                </ul>
                <h3>v 2.0.376.16</h3>
                <ul>
                    <li>
                        <a href="reports">РМ &quot;Отчеты&quot;</a>: исправлена сортировка по
                        колонкам в деталях по отчету
                    </li>
                </ul>
                <h3>v 2.0.376.15</h3>
                <ul>
                    <li>Исправление авторизации</li>
                </ul>
                <h3>v 2.0.375.15</h3>
                <ul>
                    <li>Добавлены новые клаймы TradeOrgId и Outlets</li>
                </ul>
                <h3>v 2.0.374.15</h3>
                <ul>
                    <li>Включение возможности редактирования роли для CRM</li>
                </ul>
                <h3>v 2.0.373.15</h3>
                <ul>
                    <li>
                        Настройка оформления таблиц в Excel-файлах при выгрузке данных из рабочих
                        мест
                    </li>
                </ul>
                <h3>v 2.0.372.15</h3>
                <ul>
                    <li>Аутентификация: Исправлена ошибка с обновлением токена</li>
                </ul>
                <h3>v 2.0.371.15</h3>
                <ul>
                    <li>Удаление утилиты для обновления БД</li>
                    <li>Точечная настройка тестов безопасности</li>
                </ul>
                <h3>v 2.0.370.15</h3>
                <ul>
                    <li>[b-23807] Перу: Увеличение срока жизни токена доступа до 3 часов</li>
                </ul>
                <h3>v 2.0.369.15</h3>
                <ul>
                    <li>РМ Лидогенераторы: Оптимизация. Принудительное использование индексов</li>
                </ul>
                <h3>v 2.0.368.15</h3>
                <ul>
                    <li>
                        Исправление отключения элементов в{' '}
                        <a href="scoringsettings">РМ &quot;Настройки скоринга&quot; </a> и{' '}
                        <a href="tariffprocedureparams">
                            РМ &quot;Наборы параметров для процедур&quot;
                        </a>
                        на основе ролей
                    </li>
                </ul>
                <h3>v 2.0.367.15</h3>
                <ul>
                    <li>Интеграционное тестирование: Бренды</li>
                    <li>Интеграционное тестирование: Логи действий пользователя</li>
                    <li>Интеграционное тестирование: Адреса</li>
                    <li>Интеграционное тестирование: Отказной трафик</li>
                </ul>
                <h3>v 2.0.366.15</h3>
                <ul>
                    <li>Добавлены тесты для большинства базовых и части мейн компонентов</li>
                    <li>Добавлены тесты для рабочих мест</li>
                    <li>Удален хук useSidebarMenuState (не используется)</li>
                </ul>
                <h3>v 2.0.365.15</h3>
                <ul>
                    <li>Тип данных для даты в excel файлах</li>
                </ul>
                <h3>v 2.0.364.15</h3>
                <ul>
                    <li>создание и обновление пользователей црм</li>
                </ul>
                <h3>v 2.0.363.15</h3>
                <ul>
                    <li>Добавление тестов для компонентов</li>
                </ul>
                <h3>v 2.0.362.15</h3>
                <ul>
                    <li>Удален Испанский язык</li>
                    <li>Добавлен Узбекский язык</li>
                </ul>
                <h3>v 2.0.362.14</h3>
                <ul>
                    <li>Интеграционные тесты: Пользователи: Исправлены скрипты инициализации</li>
                </ul>
                <h3>v 2.0.361.14</h3>
                <ul>
                    <li>РМ Переводчик: Исправлена загрузка файлов</li>
                </ul>
                <h3>v 2.0.360.14</h3>
                <ul>
                    <li>Добавление маски номера телефона для Пакистана</li>
                </ul>
                <h3>v 2.0.359.14</h3>
                <ul>
                    <li>Добавлены недостающие проверки ролей для РМ &quot;Группы тарифов&quot;</li>
                </ul>
                <h3>v 2.0.358.14</h3>
                <ul>
                    <li>РМ Лидгены: Добавлена колонка для одобренных заявок</li>
                </ul>
                <h3>v 2.0.357.14</h3>
                <ul>
                    <li>Повышение безопасности</li>
                </ul>
                <h3>v 2.0.356.14</h3>
                <ul>
                    <li>Аутентификация: Асимметричное RSA Шифрование JWT</li>
                </ul>
                <h3>v 2.0.355.14</h3>
                <ul>
                    <li>Передача культуры в заголовках запросов</li>
                </ul>
                <h3>v 2.0.354.14</h3>
                <ul>
                    <li>Исправление предупреждений от EF Core</li>
                    <li>Удаление неиспользуемых компонент</li>
                    <li>Добавление роли для выгрузки в Excel в РМ &quot;Логи СМС&quot;</li>
                    <li>Переработка фильтра в РМ &quot;Группы тарифов&quot;</li>
                    <li>
                        Перенос атрибута авторизации в базовый контроллер (решение ошибки
                        &quot;Mixed Content&quot;, когда был не указан атрибут)
                    </li>
                    <li>
                        Очистка ветки от старых настроек и артефактов после разделения на отдельные
                        ветки для инстансов
                    </li>
                    <li>Небольшой рефакторинг кода</li>
                    <li>Добавление маски телефона для Узбекистана</li>
                    <li>
                        Добавление eslint в devDependencies (ошибка при выполнении хуков (ENOENT: no
                        such file or directory, lstat))
                    </li>
                    <li>Изменение адресов запросов для работы с переводами</li>
                    <li>
                        Обновление <code>prettier</code> до версии 3.1.0
                    </li>
                    <li>
                        Обновление <code>prettier-plugin-organize-imports</code> до версии 3.2.4
                    </li>
                    <li>
                        Обновление <code>husky</code> до версии 0.6.3
                    </li>
                    <li>
                        Обновление <code>csharpier</code> до версии 0.26.4
                    </li>
                    <li>
                        Отключение Emoji и кэширования скриптов для <code>husky</code>
                    </li>
                    <li>
                        Добавление ошибки при неудачном получении ограничения одновременного
                        количества ролей у одного пользователя
                    </li>
                    <li>
                        Добавление ошибки при попытке установки большего количества ролей, чем это
                        положено
                    </li>
                    <li>Обновление CI/CD</li>
                    <li>Добавление скриптов блокировки изменения файлов ядра</li>
                    <li>Исправление стилей для кнопок в поповерах</li>
                    <li>Добавление хука для автоматического удаления BOM</li>
                    <li>Добавление хука для очистки и редактирования кода</li>
                </ul>
                <h3>v 2.0.353.14</h3>
                <ul>
                    <li>fix: Аутентификация: Более точное время истечения куков авторизации</li>
                </ul>
                <h3>v 2.0.352.14</h3>
                <ul>
                    <li>Отключены перезапросы при ошибке по умолчанию</li>
                </ul>
                <h3>v 2.0.351.14</h3>
                <ul>
                    <li>Аутентификация: Очистка куков авторизации при ошибке</li>
                </ul>
                <h3>v 2.0.350.14</h3>
                <ul>
                    <li>Fix for float numbers of BaseValidatedInput component</li>
                </ul>
                <h3>v 2.0.349.14</h3>
                <ul>
                    <li>Аутентификация: Удалять куки при выходе из системы</li>
                </ul>
                <h3>v 2.0.348.14</h3>
                <ul>
                    <li>Аутентификация: Передача токена в куках</li>
                </ul>
                <h3>v 2.0.347.14</h3>
                <ul>
                    <li>Интеграционное тестирование: AccountsController</li>
                </ul>
                <h3>v 2.0.346.14</h3>
                <ul>
                    <li>ссылка на виджет CRM в переменные среды</li>
                </ul>
                <h3>v 2.0.345.14</h3>
                <ul>
                    <li>РМ Пользователи: Исправлено сохранение и изменение</li>
                </ul>
                <h3>v 2.0.344.14</h3>
                <ul>
                    <li>
                        РМ Пользователи: Добавлена возможность помечать пользователей как
                        технических
                    </li>
                    <li>Добавлена маска номера для российских номеров</li>
                    <li>
                        Максимальная длина для номера телефона без маски изменена на 12 символов
                    </li>
                </ul>
                <h3>v 2.0.343.14</h3>
                <ul>
                    <li>РМ Роли: Исправлено создание ролей с пустыми пропсами</li>
                </ul>
                <h3>v 2.0.342.14</h3>
                <ul>
                    <li>Добавлены тесты BaseDatePickerInput и BaseValidatedDatePicker</li>
                </ul>
                <h3>v 2.0.341.14</h3>
                <ul>
                    <li>РМ Роли: Добавлен пропс TradeOrgBindable</li>
                    <li>РМ Пользователи: Добавлены поля Торговая организация и Торговые точки</li>
                </ul>
                <h3>v 2.0.340.14</h3>
                <ul>
                    <li>
                        РМ <a href="roles">Роли</a>: Исправлена передача пропа
                        AllowOrderManualProcess при создании роли
                    </li>
                </ul>
                <h3>v 2.0.339.14</h3>
                <ul>
                    <li>fix: TariffGroupService: Исправлено добавление</li>
                </ul>
                <h3>v 2.0.338.14</h3>
                <ul>
                    <li>компонент для выбора даты в компоненте редактирования клиентских данных</li>
                </ul>
                <h3>v 2.0.337.14</h3>
                <ul>
                    <li>РМ Роли: Исправлено отображение доступов к лидгенам</li>
                </ul>
                <h3>v 2.0.336.14</h3>
                <ul>
                    <li>Сохранение клеймов доступа к тарифам на стороне клиента</li>
                </ul>
                <h3>v 2.0.335.14</h3>
                <ul>
                    <li>OrderService: Исправлены данные для таск сервиса</li>
                </ul>
                <h3>v 2.0.335.13</h3>
                <ul>
                    <li>
                        РМ <a href="reports">Отчеты</a>: Исправлен баг с отображением пропсов
                    </li>
                    <li>
                        Добавлен sql скрипт с необходимыми изменениями для нового отчета &quot;Отчет
                        по просрочке&quot;
                    </li>
                </ul>
                <h3>v 2.0.335.12</h3>
                <ul>
                    <li>
                        РМ <a href="paymentstoclients">&quot;Выплаты клиентам&quot;</a>: Исправлен
                        запрос на получение информации по выплате клиенту
                    </li>
                </ul>
                <h3>v 2.0.335.11</h3>
                <ul>
                    <li>
                        РМ <a href="paymentstoclients">&quot;Выплаты клиентам&quot;</a>: Исправлены
                        баги и доработан функционал повторной выплаты клиенту
                    </li>
                    <li>
                        РМ <a href="paymentstoclients">&quot;Выплаты клиентам&quot;</a>: Исправлена
                        сортировка по ID заявки
                    </li>
                    <li>
                        РМ <a href="paymentstoclients">&quot;Выплаты клиентам&quot;</a>: Исправлен
                        запрос получения данных для модалки
                    </li>
                </ul>
                <h3>v 2.0.335.10</h3>
                <ul>
                    <li>Компонент для редактирования данных клиента без поповера</li>
                </ul>
                <h3>v 2.0.334.10</h3>
                <ul>
                    <li>
                        Исправление преобразования значения в <code>BaseValidatedInput</code> для
                        типа <code>number</code>
                    </li>
                </ul>
                <h3>v 2.0.333.10</h3>
                <ul>
                    <li>
                        Исправление сохранения значения в <code>Input</code>
                    </li>
                </ul>
                <h3>v 2.0.332.10</h3>
                <ul>
                    <li>
                        Исправлен ререндер <code>BaseInput</code> при получении null
                    </li>
                </ul>
                <h3>v 2.0.331.10</h3>
                <ul>
                    <li>Исправлен компонент выбора даты и времени</li>
                </ul>
                <h3>v 2.0.330.10</h3>
                <ul>
                    <li>
                        Добавлен проп для ролей <code>CanViewClientPersonalData</code>
                    </li>
                    <li>Добавлено отключение автоматического тултипа в датагриде</li>
                    <li>
                        Добавлена возможность обратного отсчета в хук <code>useTimer</code>
                    </li>
                    <li>
                        Доработан компонент <code>Timer</code>: добавлена возможность передать
                        кастомный форматтер, добавлен обратный отсчет
                    </li>
                </ul>
                <h3>v 2.0.329.10</h3>
                <ul>
                    <li>
                        РМ Лидгены: Замена пробелов на подчеркивания в названиях при переносе в реф
                        ссылки
                    </li>
                    <li>РМ Лидгены: Проверки постбэков</li>
                    <li>PropsController: Проверка доступа к лидгенам в отчетах</li>
                </ul>
                <h3>v 2.0.328.10</h3>
                <ul>
                    <li>
                        Исправлен сброс значений в зависимых полях BaseValidatedLinkedDropDownList
                    </li>
                </ul>
                <h3>v 2.0.327.10</h3>
                <ul>
                    <li>Исправлен тултип для заблокированного дропдауна</li>
                </ul>
                <h3>v 2.0.326.10</h3>
                <ul>
                    <li>Исправлена работа пропа rows в BaseInput</li>
                </ul>
                <h3>v 2.0.325.10</h3>
                <ul>
                    <li>Поправлен валидатор клиентских данных</li>
                </ul>
                <h3>v 2.0.325.9</h3>
                <ul>
                    <li>
                        Исправлено форматирование номера телефона клиента в модалке{' '}
                        <a href="clients">РМ &quot;Клиенты&quot;</a>
                    </li>
                </ul>
                <h3>v 2.0.325.8</h3>
                <ul>
                    <li>Исправлен поиск по фио в заявках</li>
                    <li>Исправлен поиск по фио в клиентах</li>
                </ul>
                <h3>v 2.0.325.7</h3>
                <ul>
                    <li>Исправлена передача параметров в sql запрос</li>
                </ul>
                <h3>v 2.0.325.6</h3>
                <ul>
                    <li>Правка отображение графика тарифа</li>
                </ul>
                <h3>v 2.0.325.5</h3>
                <ul>
                    <li>
                        Обновление <code>csharpier</code> до версии <strong>0.25.0</strong>
                    </li>
                    <li>
                        Обновление <code>husky</code> до версии <strong>0.6.2</strong>
                    </li>
                    <li>Добавлен хук, который проверяет название ветки</li>
                    <li>Добавлен хук, который проставляет номер задачи в описание коммита</li>
                    <li>
                        Обновление <code>prettier-plugin-organize-imports</code> до версии{' '}
                        <strong>3.2.2</strong>
                    </li>
                    <li>
                        Добавлена автоматическая установка <code>husky</code> при сборке проекта
                    </li>
                    <li>
                        Обновление <code>prettier</code> до версии <strong>3.0.3</strong>
                    </li>
                    <li>Актуализированы настройки хуков</li>
                </ul>
                <h3>v 2.0.324.5</h3>
                <ul>
                    <li>
                        Исправлено переключение вкладок при невалидном поле в модалке пользователей
                    </li>
                </ul>
                <h3>v 2.0.323.5</h3>
                <ul>
                    <li>
                        Доработан форматтер строки поиска: добавлена возможность возвращать
                        undefined
                    </li>
                </ul>
                <h3>v 2.0.322.5</h3>
                <ul>
                    <li>Удаление расширения из переданного имени файла</li>
                </ul>
                <h3>v 2.0.321.5</h3>
                <ul>
                    <li>
                        Добавлен пропс <code>AllowOrderManualProcess</code> в роли #157
                    </li>
                    <li>
                        Исправлено сохранение пропсов: сохраняются только те пропсы которые есть на
                        текущем инстансе и только для ролей верхнего уровня
                    </li>
                    <li>Исправлено форматирование boolean пропсов</li>
                </ul>
                <h3>v 2.0.320.5</h3>
                <ul>
                    <li>Обновление db updater до версии 0.4: расширение названия конфигурации</li>
                </ul>
                <h3>v 2.0.319.5</h3>
                <ul>
                    <li>РМ Лидогенераторы: Добавлены лимиты в постбэки</li>
                    <li>РМ Лидогенераторы: Добавлена проверка доступа к лидогенераторам</li>
                </ul>
                <h3>v 2.0.318.5</h3>
                <ul>
                    <li>Добавлена всплывающая подсказка в базовый DropDown</li>
                </ul>
                <h3>v 2.0.317.5</h3>
                <ul>
                    <li>
                        РМ Группы тарифов: Исправлена ошибка с переключением галочки &quot;Только
                        для новых клиентов&quot;
                    </li>
                    <li>
                        РМ Роли: Исправлена ошибка с переключением доступа ко всем заявкам во
                        вкладке &quot;Дополнительные возможности&quot;
                    </li>
                </ul>
                <h3>v 2.0.316.5</h3>
                <ul>
                    <li>Исправлено форматирование пропсов перед сохранением в модалке ролей</li>
                </ul>
                <h3>v 2.0.315.5</h3>
                <ul>
                    <li>Исправлена загрузка платежа для займа в статусе grace</li>
                </ul>
                <h3>v 2.0.315.4</h3>
                <ul>
                    <li>Добавлен счетчик количества займов клиента в гриде заявок</li>
                </ul>
                <h3>v 2.0.315.3</h3>
                <ul>
                    <li>Исправление поиска оператора по ФИО в окне смены оператора у заявки</li>
                </ul>
                <h3>v 2.0.315.2</h3>
                <ul>
                    <li>Реализовано РМ &quot;Выплаты клиентам&quot;</li>
                </ul>
                <h3>v 2.0.315.1</h3>
                <ul>
                    <li>Добавлен хук для таймера</li>
                    <li>Компонент Timer переписан с использованием нового хука</li>
                    <li>Добавлен тип для обязательности одного из свойств типа</li>
                    <li>Доработаны конфиги Перу</li>
                </ul>
                <h3>v 2.0.314.1</h3>
                <ul>
                    <li>Кнопки управления вынесены в отдельную папку</li>
                    <li>Модалка поделена на отдельные блоки</li>
                </ul>
                <h3>v 2.0.313.1</h3>
                <ul>
                    <li>Добавлены дополнительные проверки при разборе описания МР</li>
                    <li>Если описание МР пустое, то берется заголовок МР</li>
                    <li>Добавлен шаблон описания МР</li>
                </ul>
                <h3>v 2.0.312.1</h3>
                <ul>
                    <li>Выделен компонент выбора нескольких элементов в базовые #171</li>
                </ul>
                <h3>v 2.0.311.1</h3>
                <ul>
                    <li>Обновление CI/CD</li>
                </ul>
                <h3>v 2.0.310.1</h3>
                <ul>
                    <li>Подготовка и настройка нового инстанса</li>
                </ul>
                <h3>v 2.0.309.1</h3>
                <ul>
                    <li>РМ Роли: Исправлено сохранение пропса editingAccess</li>
                </ul>
                <h3>v 2.0.308.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Исправлен основной отчет</li>
                </ul>
                <h3>v 2.0.307.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Исправлен основной отчет</li>
                </ul>
                <h3>v 2.0.306.1</h3>
                <ul>
                    <li>
                        Добавлена возможность передавать кастомный парсер для парсинга параметра
                        поисковой строки в фильтр
                    </li>
                    <li>Добавлен новый компонент BaseValidatedRadioButton</li>
                    <li>Фильтр ролей переведен на валидируемые компоненты</li>
                </ul>
                <h3>v 2.0.305.1</h3>
                <ul>
                    <li>Рефакторинг сервиса по работе с файлами на беке</li>
                </ul>
                <h3>v 2.0.304.1</h3>
                <ul>
                    <li>РМ Пользователи: Кнопка удаления переименована на Деактивировать</li>
                    <li>РМ Пользователи: Добавлена возможность восстановления пользователей</li>
                    <li>РМ Пользователи: Поле IsActive в таблице</li>
                    <li>РМ Пользователи: Удаление через флаг IsActive</li>
                </ul>
                <h3>v 2.0.303.1</h3>
                <ul>
                    <li>
                        Исправлен баг когда при сохранении роли создавались пропсы с пустыми
                        значениями
                    </li>
                </ul>
                <h3>v 2.0.302.1</h3>
                <ul>
                    <li>Калбек на сохранение из базового поповера</li>
                </ul>
                <h3>v 2.0.301.1</h3>
                <ul>
                    <li>Изменен тип клайма TariffEditingAccess</li>
                    <li>Исправлен баг с передачей контейнера в пропсах</li>
                </ul>
                <h3>v 2.0.300.1</h3>
                <ul>
                    <li>Добавление параметра в BaseDataGrid maxBlockSize</li>
                    <li>
                        Добавление параметра в DropdownFilterButtonProps text и логики отображения
                        компонента
                    </li>
                    <li>Добавление логики в TostProvider</li>
                </ul>
                <h3>v 2.0.299.1</h3>
                <ul>
                    <li>
                        Исправлен баг с необновление текущего js-объекта таблицы при клике на строку
                        таблицы
                    </li>
                </ul>
                <h3>v 2.0.298.1</h3>
                <ul>
                    <li>
                        Исправлен баг когда маппинг UserDto падал при парсинге пропса EditingAccess
                    </li>
                </ul>
                <h3>v 2.0.297.1</h3>
                <ul>
                    <li>
                        Добавлена передача контейнера и дизейбла в выпадающий список внутри динамик
                        листа в пропсах
                    </li>
                    <li>Добавлен disabled в тип PropExtended</li>
                    <li>
                        Введен параметр disabled в TariffGroupChangeModal для блокировки полей при
                        отсутствии ролей
                    </li>
                </ul>
                <h3>v 2.0.296.1</h3>
                <ul>
                    <li>Получение пропсов роли пользователя в клаймсах</li>
                </ul>
                <h3>v 2.0.295.1</h3>
                <ul>
                    <li>Настройка CI/CD</li>
                </ul>
                <h3>v 2.0.294.1</h3>
                <ul>
                    <li>Доработана передача параметров min, max и container в пропсы</li>
                </ul>
                <h3>v 2.0.293.1</h3>
                <ul>
                    <li>
                        Отключение пользовательских настроек при отображении столбца с флагом
                        notHidden
                    </li>
                </ul>
                <h3>v 2.0.292.1</h3>
                <ul>
                    <li>
                        Добавление недостающих запросов после изменения CurrentUserService и
                        TokenService
                    </li>
                </ul>
                <h3>v 2.0.291.1</h3>
                <ul>
                    <li>Перенос изменений CurrentUserService и TokenService</li>
                </ul>
                <h3>v 2.0.290.1</h3>
                <ul>
                    <li>Компонент таймера</li>
                </ul>
                <h3>v 2.0.289.1</h3>
                <ul>
                    <li>
                        РМ Роли: Добавлена вкладка &quot;Дополнительные возможности&quot; в модалке
                        ролей
                    </li>
                </ul>
                <h3>v 2.0.288.1</h3>
                <ul>
                    <li>Excel: Исправлено форматирование</li>
                </ul>
                <h3>v 2.0.287.1</h3>
                <ul>
                    <li>Отказной трафик: Исправлен путь до файлов</li>
                    <li>Исправлен &quot;FilesUrl&quot;</li>
                </ul>
                <h3>v 2.0.286.1</h3>
                <ul>
                    <li>Рефакторинг пропсов</li>
                </ul>
                <h3>v 2.0.285.1</h3>
                <ul>
                    <li>РМ Словари: Исправлено сохранение переводов</li>
                </ul>
                <h3>v 2.0.284.1</h3>
                <ul>
                    <li>РМ Роли: Выгрузка Excel</li>
                    <li>РМ Пользователи: Выгрузка Excel</li>
                </ul>
                <h3>v 2.0.283.1</h3>
                <ul>
                    <li>Аутентификация: Обновление токенов один раз для всех запросов</li>
                </ul>
                <h3>v 2.0.282.1</h3>
                <ul>
                    <li>Исправление предупреждения Compiler Warning (level 3) CS0693</li>
                    <li>Удаление дубликатов сервисов при внедрении зависимостей</li>
                </ul>
                <h3>v 2.0.281.1</h3>
                <ul>
                    <li>
                        BaseDropDownList: Исправлена ошибка с типами значений и идентификаторов в
                        списках
                    </li>
                </ul>
                <h3>v 2.0.280.1</h3>
                <ul>
                    <li>
                        Исправлена ошибка, когда при установке свойства disabled в компоненте
                        BaseValidatedDynamicList не отключалась возможность добавления новых
                        элементов
                    </li>
                </ul>
                <h3>v 2.0.279.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Ограничение на период в фильтре</li>
                    <li>WorkplaceStateProvider: Префикс в фильтре для Array элементов</li>
                </ul>
                <h3>v 2.0.278.1</h3>
                <ul>
                    <li>Исправлено создание нотификаций об обновлении переводов</li>
                </ul>
                <h3>v 2.0.277.1</h3>
                <ul>
                    <li>Рефакторинг передачи параметров процедур для HistTableService</li>
                </ul>
                <h3>v 2.0.276.1</h3>
                <ul>
                    <li>Изменение процесса получения файлов с документацией для swagger</li>
                </ul>
                <h3>v 2.0.275.1</h3>
                <ul>
                    <li>Реализовано рабочее место &quot;Прескоринг&quot;</li>
                </ul>
                <h3>v 2.0.274.1</h3>
                <ul>
                    <li>Включение swagger-а для всех конфигураций</li>
                    <li>Добавление недостающих конфигураций</li>
                    <li>Рефакторинг csproj файлов</li>
                </ul>
                <h3>v 2.0.273.1</h3>
                <ul>
                    <li>
                        BaseDatePicker: Исправлены формат времени и ошибка при некорректном значении
                    </li>
                </ul>
                <h3>v 2.0.272.1</h3>
                <ul>
                    <li>Исправлено сохранение переводов словарей</li>
                </ul>
                <h3>v 2.0.271.1</h3>
                <ul>
                    <li>
                        Исправлен баг когда не отображались значения торговых организаций в модалке
                        анкеты клиента
                    </li>
                    <li>Исправлен баг когда не очищалось поле в BaseValidatedDropDownList</li>
                </ul>
                <h3>v 2.0.270.1</h3>
                <ul>
                    <li>Исправлен вызов процедур: Параметры указаны явно</li>
                </ul>
                <h3>v 2.0.269.1</h3>
                <ul>
                    <li>Системный контроллер (возвращает версию продукта)</li>
                    <li>Проект утилиты для автоматического обновления БД силами ci/cd</li>
                </ul>
                <h3>v 2.0.268.1</h3>
                <ul>
                    <li>Обработка ошибок при загрузки картинки</li>
                </ul>
                <h3>v 2.0.267.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Оптимизация SQL</li>
                </ul>
                <h3>v 2.0.266.1</h3>
                <ul>
                    <li>
                        Исправлено редактирование переводов словарей если isUserEditable = false
                    </li>
                    <li>Отключено редактирование пропсов словаря если isUserEditable = false</li>
                    <li>Исправлен дизейбл пропсов с множеством значений</li>
                </ul>
                <h3>v 2.0.265.1</h3>
                <ul>
                    <li>
                        Исправление ошибки отображения нотификации с 0% прогресса загрузки файла
                    </li>
                </ul>
                <h3>v 2.0.264.1</h3>
                <ul>
                    <li>Единые форматы дат для фронта и бека</li>
                    <li>Формат даты из настроек для сгенерированных файлов excel</li>
                </ul>
                <h3>v 2.0.263.1</h3>
                <ul>
                    <li>BaseDatePicker: Исправлена отрисовка если container ссылается на null</li>
                </ul>
                <h3>v 2.0.262.1</h3>
                <ul>
                    <li>Добавление маски телефона для Мексики</li>
                </ul>
                <h3>v 2.0.261.1</h3>
                <ul>
                    <li>Удален rowRef из DataGridProp</li>
                    <li>
                        Исправлен баг с пагинацией при сбросе номера страницы в параметрах запроса
                    </li>
                </ul>
                <h3>v 2.0.260.1</h3>
                <ul>
                    <li>Добавлен атрибут сортировки столбцов при выгрузке в Excel</li>
                </ul>
                <h3>v 2.0.259.1</h3>
                <ul>
                    <li>BaseDatePicker: Удален portalId</li>
                    <li>
                        РМ Лидогенераторы: Исправлено отображение календаря в параметрах тарификации
                    </li>
                </ul>
                <h3>v 2.0.258.1</h3>
                <ul>
                    <li>
                        Исправлен баг когда при сохранении на какое-то время показывались старые
                        значения
                    </li>
                    <li>
                        Исправлен баг когда после сохранения при первом открытии поля в поповере не
                        очищались
                    </li>
                </ul>
                <h3>v 2.0.257.1</h3>
                <ul>
                    <li>Уведомления: Отображать максимум 3 уведомления</li>
                    <li>Уведомления: Показывать сначала новые</li>
                    <li>Cброс вида таблиц на вид по умолчанию</li>
                    <li>Разные JWT ключи для разных инстансов запускаемых локально</li>
                    <li>BaseDatePicker: Корректная отрисовка всплывающего календаря</li>
                </ul>
                <h3>v 2.0.256.1</h3>
                <ul>
                    <li>Функции для получения даты начала и конца дня</li>
                </ul>
                <h3>v 2.0.255.1</h3>
                <ul>
                    <li>Избавление от react-modal-hook</li>
                </ul>
                <h3>v 2.0.254.1</h3>
                <ul>
                    <li>
                        Рефакторинг фронтенда в области работы с датами (избавление от moment.js)
                    </li>
                </ul>
                <h3>v 2.0.253.1</h3>
                <ul>
                    <li>Версия ради версии</li>
                </ul>
                <h3>v 2.0.252.1</h3>
                <ul>
                    <li>РМ Наборы параметров для процедур: Исправлена асинхронность</li>
                </ul>
                <h3>v 2.0.251.1</h3>
                <ul>
                    <li>DataContext: Исправлен вызов DbSessionUserSet</li>
                </ul>
                <h3>v 2.0.250.1</h3>
                <ul>
                    <li>
                        Переработан поиск по сайдбару, теперь поиск работает и по статусам заявок
                    </li>
                    <li>
                        Доработано разворачивание пунктов меню по которым поиск выдал результаты
                    </li>
                    <li>
                        Удален OrderStatusesFilterProvider. Связь счетчиков и РМ &quot;Заявки&quot;
                        переделана на использование поисковой строки.
                    </li>
                    <li>Хук useSidebarMenuState переделан в провайдер SidebarProvider</li>
                </ul>
                <h3>v 2.0.249.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Исправлены sql скрипты</li>
                </ul>
                <h3>v 2.0.248.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Увеличен таймаут на запрос</li>
                </ul>
                <h3>v 2.0.247.1</h3>
                <ul>
                    <li>РМ Заявки: Скрытие меню если нет роли &quot;orderGet&quot;</li>
                    <li>Авторизация: Корректный вход пользователя без ролей</li>
                    <li>BaseDropDownList: Рефакторинг стилей</li>
                </ul>
                <h3>v 2.0.246.1</h3>
                <ul>
                    <li>РМ Пользователи: Исправлена валидация имени пользователя</li>
                </ul>
                <h3>v 2.0.245.1</h3>
                <ul>
                    <li>Исправление тестов</li>
                </ul>
                <h3>v 2.0.244.1</h3>
                <ul>
                    <li>Обновление заголовка РМ при изменении кода перевода</li>
                </ul>
                <h3>v 2.0.243.1</h3>
                <ul>
                    <li>Кэш ролей: Сброс при изменении ролей</li>
                    <li>РМ Роли: Сброс кэша через интерфейс пользователя</li>
                    <li>
                        Обновление токена при получении уведомления &quot;PermissionsUpdated&quot;
                    </li>
                </ul>
                <h3>v 2.0.242.1</h3>
                <ul>
                    <li>Добавлен react-modal-hook</li>
                </ul>
                <h3>v 2.0.241.1</h3>
                <ul>
                    <li>
                        Исправление закрытия окна добавления/редактирования пользователя при
                        возникновении ошибки
                    </li>
                </ul>
                <h3>v 2.0.240.1</h3>
                <ul>
                    <li>[16099] РМ Лидогенераторы: Изменение связи лидогенераторов с заявками</li>
                    <li>[16099] РМ Лидогенераторы: Добавлены поля в статистику</li>
                    <li>[16099] РМ Лидогенераторы: Исправлено поле AppsNewToAllOrdersDt</li>
                    <li>[16802] РМ Лидогенераторы: Добавлен отчет По часам</li>
                    <li>
                        BaseDataGrid: Добавлены кастомные подсказки, исправлено свойство showAlways
                    </li>
                    <li>[16099] РМ Лидогенераторы: Добавлены аннотации в шапку таблиц</li>
                    <li>РМ Лидогенераторы: Параметр UTM по умолчанию</li>
                    <li>[16099] РМ Лидогенераторы: Исправление ширины столбцов</li>
                    <li>[16099] РМ Лидогенераторы: Скрывать неактивные лидгены по умолчанию</li>
                </ul>
                <h3>v 2.0.239.1</h3>
                <ul>
                    <li>
                        Оптимизирован алгоритм перезапроса переводов при изменении таблицы
                        [web].Translation
                    </li>
                    <li>
                        Исправлен баг когда при удалении переводов в имени которых содержался символ
                        &apos;_&apos; удаление не происходило или удалялся другой перевод
                    </li>
                </ul>
                <h3>v 2.0.238.1</h3>
                <ul>
                    <li>РМ Переводчик: Исправлен поиск по значению</li>
                </ul>
                <h3>v 2.0.237.1</h3>
                <ul>
                    <li>РМ Словари: Запрещено изменение и удаление нередактируемых словарей</li>
                    <li>РМ Отчеты: Изменена иконка</li>
                </ul>
                <h3>v 2.0.236.1</h3>
                <ul>
                    <li>Из main вынесен РМ Скидка на услуги</li>
                </ul>
                <h3>v 2.0.235.1</h3>
                <ul>
                    <li>
                        Отрисовка поповера заголовка таблицы только при наличии массива колонок для
                        сортировки
                    </li>
                </ul>
                <h3>v 2.0.234.1</h3>
                <ul>
                    <li>Небольшой рефакторинг типов пропсов компонента PendingGrid</li>
                </ul>
                <h3>v 2.0.233.1</h3>
                <ul>
                    <li>Добавление нового компонента BaseValidatedDropDownMultiList</li>
                </ul>
                <h3>v 2.0.232.1</h3>
                <ul>
                    <li>Переработан BaseValidatedLinkedDropDownList</li>
                    <li>Удалены BaseLinkedDropDownList и BaseLinkedDropDownProvider</li>
                    <li>
                        Внесены исправления в модалку анкеты клиента в связи с переработкой
                        BaseValidatedLinkedDropDownList
                    </li>
                    <li>Убраны лишние атрибуты из QuestionaryTradeOrg</li>
                </ul>
                <h3>v 2.0.231.1</h3>
                <ul>
                    <li>Исправлена маска телефона в Перу</li>
                    <li>Доработан класс card-for-table</li>
                    <li>Исправлен баг с передачей класса ячейки датагрида</li>
                </ul>
                <h3>v 2.0.230.1</h3>
                <ul>
                    <li>Обновление JWT токена пользователя при изменении своих ролей</li>
                </ul>
                <h3>v 2.0.229.1</h3>
                <ul>
                    <li>ISO формат даты и времени для соответствующего компонента</li>
                </ul>
                <h3>v 2.0.228.1</h3>
                <ul>
                    <li>Ограничение размера ответа в логах пользователя</li>
                </ul>
                <h3>v 2.0.227.1</h3>
                <ul>
                    <li>Исправление запроса ролей ЦРМ у пользователя</li>
                </ul>
                <h3>v 2.0.226.1</h3>
                <ul>
                    <li>Исправление работы с массивами в урл</li>
                </ul>
                <h3>v 2.0.225.1</h3>
                <ul>
                    <li>Добавлено отображение браузерных нотификаций в NotifyProvider</li>
                    <li>Добавлено обновление счетчиков и грида заявок по нотификации</li>
                </ul>
                <h3>v 2.0.224.1</h3>
                <ul>
                    <li>
                        Доработаны стили заблокированного BaseDropDownList для соответствия с
                        остальными инпутами
                    </li>
                    <li>Поправлена маска номера телефона для Перу</li>
                </ul>
                <h3>v 2.0.223.1</h3>
                <ul>
                    <li>Исправлена фильтрация заявок</li>
                </ul>
                <h3>v 2.0.222.1</h3>
                <ul>
                    <li>
                        Исправлено некорректное удаление подписки на нотификацию в NotifyProvider
                    </li>
                </ul>
                <h3>v 2.0.221.1</h3>
                <ul>
                    <li>
                        РМ Логи действий пользователя: Исправлен баг с логами из старого КЦ и
                        админки
                    </li>
                </ul>
                <h3>v 2.0.220.1</h3>
                <ul>
                    <li>РМ Группы тарифов: Кликабельный label у чекбокса &quot;Базовый&quot;</li>
                    <li>Исправлена точность полей типа money</li>
                    <li>Пропсы: Кликабельный label у чекбокса</li>
                </ul>
                <h3>v 2.0.219.1</h3>
                <ul>
                    <li>Исправлена работа с массивами в урл</li>
                </ul>
                <h3>v 2.0.218.1</h3>
                <ul>
                    <li>
                        Доработан DropDownFilter.tsx для корректной работы валидируемых компонентов
                        внутри фильтра
                    </li>
                    <li>
                        Исправлена валидация userName в модалке пользователей для возможности
                        использования &apos;-&apos; и &apos;_&apos; в имени пользователя
                    </li>
                </ul>
                <h3>v 2.0.217.1</h3>
                <ul>
                    <li>
                        Добавлен провайдер с периодом выбираемым в фильтрах заявок для корректной
                        работы счетчиков заявок
                    </li>
                    <li>
                        Добавлен коллбек onFilterChange в Workplace для выполнения действий при
                        изменении фильтра
                    </li>
                </ul>
                <h3>v 2.0.216.1</h3>
                <ul>
                    <li>
                        BaseDatePicker: добавлена анимация загрузки и блокировка поля при loading =
                        true
                    </li>
                </ul>
                <h3>v 2.0.215.1</h3>
                <ul>
                    <li>
                        BaseEditablePopoverInput: исправлен баг когда введенное значение не
                        очищалось при закрытии поповера по клику за его пределами
                    </li>
                    <li>
                        BaseValidatedInput: добавлено форматирование числа в соответствии с локалью
                    </li>
                    <li>
                        DropdownFilter: исправлен баг когда формат даты не менялся при переключении
                        языка
                    </li>
                </ul>
                <h3>v 2.0.214.1</h3>
                <ul>
                    <li>
                        Валидация для поля имени пользователя и обработка ошибок запроса создания
                        пользователя
                    </li>
                </ul>
                <h3>v 2.0.213.1</h3>
                <ul>
                    <li>Исправлен баг с отображением подсказок заголовков датагрида в mozilla</li>
                    <li>
                        Исправлен баг когда при бэд реквесте от црм сохранялись изменения по
                        пользователю
                    </li>
                </ul>
                <h3>v 2.0.212.1</h3>
                <ul>
                    <li>
                        Скрыт проп canViewAllOrders для ролей не являющихся ролями верхнего уровня
                    </li>
                </ul>
                <h3>v 2.0.211.1</h3>
                <ul>
                    <li>Компонент для скачивания файлов</li>
                </ul>
                <h3>v 2.0.210.1</h3>
                <ul>
                    <li>Удаление лишних элементов</li>
                </ul>
                <h3>v 2.0.209.1</h3>
                <ul>
                    <li>
                        Скрытие ссылки в меню на РМ &quot;Скидка на услуги&quot;, если нет роли на
                        просмотр данных
                    </li>
                </ul>
                <h3>v 2.0.208.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Исправление высоты</li>
                </ul>
                <h3>v 2.0.207.1</h3>
                <ul>
                    <li>
                        Добавлен функционал переключения табов и элементов аккордиона при фокусе на
                        невалидном инпуте внутри них
                    </li>
                    <li>
                        Добавлена ревалидация в BaseValidatedDynamicList при добавлении или удалении
                        записей
                    </li>
                </ul>
                <h3>v 2.0.206.1</h3>
                <ul>
                    <li>РМ Пользователи: Исправлен баг при удалении пользователя</li>
                </ul>
                <h3>v 2.0.205.1</h3>
                <ul>
                    <li>
                        Исправление ошибки загрузки данных фильтра для РМ &quot;Наборы параметров
                        для процедур&quot;
                    </li>
                    <li>Добавление масок телефонов для Мексики и Перу</li>
                    <li>Исправление предупреждений от EF Core</li>
                </ul>
                <h3>v 2.0.204.1</h3>
                <ul>
                    <li>
                        Исправление ошибки &quot;Невозможно просмотреть данные, которые не влезли в
                        строку фильтра&quot;
                    </li>
                </ul>
                <h3>v 2.0.203.1</h3>
                <ul>
                    <li>РМ Отказной трафик: Исправление багов в интерфейсе</li>
                </ul>
                <h3>v 2.0.202.1</h3>
                <ul>
                    <li>Новое РМ &quot;Скидка на услуги&quot;</li>
                </ul>
                <h3>v 2.0.201.1</h3>
                <ul>
                    <li>Компонент для валидации формы целиком.</li>
                </ul>
                <h3>v 2.0.200.1</h3>
                <ul>
                    <li>Скрытие пункта меню группы заявок в котором нет пунктов.</li>
                </ul>
                <h3>v 2.0.199.1</h3>
                <ul>
                    <li>
                        Изменена логика работы метода PingCrmApi. В случае если от crm приходит 200
                        код возвращает &quot;Work&quot; во всех остальных случаях &quot;Unwork&quot;
                    </li>
                </ul>
                <h3>v 2.0.198.1</h3>
                <ul>
                    <li>
                        Добавление отсутствующей маски в строке фильтра в РМ &quot;Логи СМС&quot;
                    </li>
                </ul>
                <h3>v 2.0.197.1</h3>
                <ul>
                    <li>Исправление вывода наименования бренда в переводчике</li>
                </ul>
                <h3>v 2.0.196.1</h3>
                <ul>
                    <li>Обновление версии react-datepicker с 4.13.0 до 4.14.0</li>
                    <li>Исправление работы валидации для DatePicker</li>
                </ul>
                <h3>v 2.0.195.1</h3>
                <ul>
                    <li>Рефакторинг компонента &quot;OrderStatusesProvider&quot;</li>
                </ul>
                <h3>v 2.0.194.1</h3>
                <ul>
                    <li>Рефакторинг настроек запуска и публикации</li>
                    <li>Исправление запросов ролей: Добавлен ранг</li>
                </ul>
                <h3>v 2.0.193.1</h3>
                <ul>
                    <li>Исправление падения интерфейса при вводе некорректной даты в en локали</li>
                </ul>
                <h3>v 2.0.192.1</h3>
                <ul>
                    <li>Исправление работы масок для BaseEditablePopoverInput</li>
                </ul>
                <h3>v 2.0.191.1</h3>
                <ul>
                    <li>
                        Исправление возврата значения при установленной маске в BaseValidatedInput
                    </li>
                </ul>
                <h3>v 2.0.190.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Выбор нескольких лидгенов</li>
                </ul>
                <h3>v 2.0.189.1</h3>
                <ul>
                    <li>
                        Добавлена поддержка возвращения данных без маски, если не установлен атрибут
                        preserveMask или он равен false
                    </li>
                    <li>Добавлен список масок для валидации телефонов под разные страны</li>
                    <li>
                        Добавлен метод получения номера телефона, с примененной маской, в
                        автоматическом режиме
                    </li>
                    <li>Добавлен метод получения маски номера телефона по названию страны</li>
                    <li>Добавлен метод получения маски по введенному номеру телефона</li>
                    <li>Добавлен метод приведения номера телефона к указанной маске</li>
                    <li>
                        Добавление новой реализации масок в SmsLogsFilter, UserChangeModal и
                        PhoneNumber
                    </li>
                    <li>Добавление расширения startsWithNumber для типа String</li>
                    <li>Исправлено положение курсора при динамическом изменении масок</li>
                    <li>Удаление устаревшего метода phoneFormatter</li>
                </ul>
                <h3>v 2.0.187.1</h3>
                <ul>
                    <li>Исправлены баги при редактировании элемента словаря</li>
                    <li>Исправлен баг с подсветкой меню при релогине</li>
                </ul>
                <h3>v 2.0.186.1</h3>
                <ul>
                    <li>Добавлено дефолтное значение для функции GetTranslation</li>
                    <li>
                        Если не найден перевод для поля Name в PropDto то будет возвращаться пустая
                        строка
                    </li>
                    <li>Поправлен фильтр групп тарифов</li>
                    <li>Поправлена строка фильтра в РМ &quot;Набор параметров процедур&quot;</li>
                    <li>Переделано получение листов для фильтра переводов</li>
                    <li>Убран колокольчик в тарифах</li>
                    <li>Поправлен лейбл в фильтре РМ &quot;Логи действий пользователя&quot;</li>
                </ul>
                <h3>v 2.0.185.1</h3>
                <ul>
                    <li>Добавлен тип DropDown с id типа int</li>
                    <li>Добавлено открытие списка дропдаун листа при фокусе на него</li>
                    <li>Переделан BaseReactHookFormValue</li>
                    <li>Добавлена передача пропа disabled в враппер BaseValidatedDynamicList</li>
                    <li>Исправлено лишний вызов функции перевода в BaseValidatedInput</li>
                    <li>Исправлен баг с удалением страниц в QuestionaryModalQuestionaries</li>
                </ul>
                <h3>v 2.0.183.1</h3>
                <ul>
                    <li>Исправление загаловка в модальном окне групп тарифов</li>
                </ul>
                <h3>v 2.0.182.1</h3>
                <ul>
                    <li>Исправление загрузки файлов на удаленный сервер по http</li>
                </ul>
                <h3>v 2.0.181.1</h3>
                <ul>
                    <li>Добавление атрибута defaultItems в BaseValidatedDropDownList</li>
                    <li>Добавление типа null в свойство id для DropDown</li>
                </ul>
                <h3>v 2.0.180.1</h3>
                <ul>
                    <li>
                        Исправление падения интерфейса после удаления валидируемого поля, в котором
                        возникли ошибки
                    </li>
                </ul>
                <h3>v 2.0.179.1</h3>
                <ul>
                    <li>Удаление ноля из фильтра</li>
                </ul>
                <h3>v 2.0.178.1</h3>
                <ul>
                    <li>Исправлены права в настройках скоринга</li>
                </ul>
                <h3>v 2.0.177.1</h3>
                <ul>
                    <li>Исправлен компонент загрузки картинок (обработка ошибок)</li>
                </ul>
                <h3>v 2.0.176.1</h3>
                <ul>
                    <li>Исправлена ошибка позиционирования календаря в пропсах</li>
                </ul>
                <h3>v 2.0.175.1</h3>
                <ul>
                    <li>
                        В модалке ролей добавлен проп отвечающий за возможность роли видеть все
                        заявки
                    </li>
                </ul>
                <h3>v 2.0.174.1</h3>
                <ul>
                    <li>Переделан сервис нотификаций на бэке</li>
                </ul>
                <h3>v 2.0.173.1</h3>
                <ul>
                    <li>Исправлено отображение выбранного названия лидгена в строке фильтра</li>
                    <li>Переделана загрузка списка лидгенов для фильтра в РМ лидгенов</li>
                    <li>Переделана функция пинга apiCrm</li>
                </ul>
                <h3>v 2.0.172.1</h3>
                <ul>
                    <li>
                        Отрефакторены базовые компоненты: BaseEditablePopoverInput,
                        BaseValidatedDatePicker и функция parseToInt
                    </li>
                </ul>
                <h3>v 2.0.171.1</h3>
                <ul>
                    <li>Добавлены ранги ролей</li>
                </ul>
                <h3>v 2.0.170.1</h3>
                <ul>
                    <li>РМ Заявки: Доработка ручных проверок файлов клиента в модальном окне</li>
                    <li>Исправление коунтеров в списке статусов заявок</li>
                </ul>
                <h3>v 2.0.169.1</h3>
                <ul>
                    <li>РМ Заявки: реализация изменения параметров займа через задачи</li>
                </ul>
                <h3>v 2.0.168.1</h3>
                <ul>
                    <li>РМ Пользователи: Исправлена колонка &quot;Телефон&quot;</li>
                    <li>Логирование: Сохранять куки, не сохранять токены</li>
                    <li>
                        РМ Логи действий пользователя: Оптимизация. В таблице убрана колонка
                        &quot;Response&quot;. В запросе удалены лишние колонки
                    </li>
                    <li>РМ Логи действий пользователя: Форматирование JSON</li>
                    <li>Отдельные SecretKey для разных инстансов</li>
                </ul>
                <h3>v 2.0.167.1</h3>
                <ul>
                    <li>РМ Лидогенераторы: Добавлено поле &quot;Окно атрибуции&quot;</li>
                    <li>РМ Лидогенераторы: Добавлены параметры тарификации</li>
                    <li>РМ Лидогенераторы: Редактировать можно только неактивные лидогенераторы</li>
                    <li>РМ Лидогенераторы: Автоматическое заполнение реферальных ссылок</li>
                    <li>РМ Лидогенераторы: Добавлены новые колонки в таблицу</li>
                    <li>РМ Лидогенераторы: Добавлена таблица &quot;По дням&quot;</li>
                    <li>РМ Лидогенераторы: Фильтр по умолчанию за последние 7 дней</li>
                </ul>
                <h3>v 2.0.166.1</h3>
                <ul>
                    <li>Разлизные мелкие исправления</li>
                </ul>
                <h3>v 2.0.165.1</h3>
                <ul>
                    <li>Исправлены баги при редактировании адреса в модалке заявок</li>
                </ul>
                <h3>v 2.0.164.1</h3>
                <ul>
                    <li>Исправлены ошибки при сохранении и удалении переводов</li>
                </ul>
                <h3>v 2.0.163.1</h3>
                <ul>
                    <li>РМ Роли: Копирование роли</li>
                </ul>
                <h3>v 2.0.162.1</h3>
                <ul>
                    <li>Исправлен баг при удалении пользователя с refresh токеном</li>
                </ul>
                <h3>v 2.0.161.1</h3>
                <ul>
                    <li>Реализован isIgnorePeriod в фильтре заявок</li>
                </ul>
                <h3>v 2.0.160.1</h3>
                <ul>
                    <li>Исправлен краш страницы при открытии модалки ролей</li>
                </ul>
                <h3>v 2.0.159.1</h3>
                <ul>
                    <li>
                        Исправлена фильтрация по статусу в РМ &quot;Заявки&quot;, при условии если у
                        пользователя есть доступ ко всем статусам
                    </li>
                </ul>
                <h3>v 2.0.158.1</h3>
                <ul>
                    <li>Доработка карточки заявки для Индии</li>
                    <li>Добавлен парамерт Тип заявки, убрана вкладка Платежи</li>
                </ul>
                <h3>v 2.0.157.1</h3>
                <ul>
                    <li>Компонент выбора файла.</li>
                </ul>
                <h3>v 2.0.156.1</h3>
                <ul>
                    <li>Разрешено назначение пользователю только ролей верхнего уровня</li>
                    <li>
                        В настройках заведено максимально возможное количество ролей у пользователя,
                        а так же реализован функционал проверки на соответствие количества ролей
                        пользователя значению в настройке
                    </li>
                </ul>
                <h3>v 2.0.155</h3>
                <ul>
                    <li>
                        Реализован пункт 14 задачи [14530] BackOffice Колумбия. РМ
                        &quot;Заявки&quot;
                    </li>
                    <li>Исправлен баг с сохранением пользователя</li>
                    <li>Исправлен баг с пендингом при сохранении или удалении пользователя</li>
                </ul>
                <h3>v 2.0.154.1</h3>
                <ul>
                    <li>
                        Реализован пункт 9 задачи [14530] BackOffice Колумбия. РМ &quot;Заявки&quot;
                    </li>
                </ul>
                <h3>v 2.0.153.1</h3>
                <ul>
                    <li>РМ Пользователи: Изменение пароля</li>
                    <li>Обработка ошибки 403</li>
                </ul>
                <h3>v 2.0.152.1</h3>
                <ul>
                    <li>
                        Реализован пункт 3 задачи [14530] BackOffice Колумбия. РМ &quot;Заявки&quot;
                    </li>
                    <li>
                        Реализован пункт 8 задачи [14530] BackOffice Колумбия. РМ &quot;Заявки&quot;
                    </li>
                    <li>Исправлен скролл модалки словарей</li>
                    <li>Уточнены типы в BaseValidatedInput</li>
                </ul>
                <h3>v 2.0.151.1</h3>
                <ul>
                    <li>
                        Индия: РМ &quot;Черные списки&quot; исправление отображения даты в
                        детализации файла по людям.
                    </li>
                </ul>
                <h3>v 2.0.150.1</h3>
                <ul>
                    <li>Индия: РМ &quot;Черные списки&quot; исправление списка ошибок.</li>
                </ul>
                <h3>v 2.0.149.1</h3>
                <ul>
                    <li>Индия: РМ &quot;Черные списки&quot; различные исправления.</li>
                </ul>
                <h3>v 2.0.148.1</h3>
                <ul>
                    <li>
                        Реализован пункт 5 задачи [14530] BackOffice Колумбия. РМ &quot;Заявки&quot;
                    </li>
                </ul>
                <h3>v 2.0.147.1</h3>
                <ul>
                    <li>
                        Реализован пункт 1 задачи [14530] BackOffice Колумбия. РМ &quot;Заявки&quot;
                    </li>
                </ul>
                <h3>v 2.0.146.1</h3>
                <ul>
                    <li>
                        Реализован пункт 7 задачи [14530] BackOffice Колумбия. РМ &quot;Заявки&quot;
                    </li>
                    <li>
                        Исправлено отображение инпута группировки таблицы &quot;Начисления&quot;
                        вкладки &quot;Заявка&quot; модалки заявок
                    </li>
                    <li>
                        Поправил баг когда по клику пункта выпадающего меню находящегося в поповере
                        тот закрывался
                    </li>
                </ul>
                <h3>v 2.0.145.1</h3>
                <ul>
                    <li>
                        Выделил обобщающий интерфейс IDataContext и его базовую реализацию
                        DataContext
                    </li>
                    <li>Заменил использование в классах DataContext на IDataContext</li>
                    <li>Изменил объявление зависимостей для работы с разными контекстами</li>
                </ul>
                <h3>v 2.0.144.1</h3>
                <ul>
                    <li>
                        Индия: РМ &quot;Черные списки&quot; переименовал таблицу ошибок обработки
                        файлов
                    </li>
                </ul>
                <h3>v 2.0.143.1</h3>
                <ul>
                    <li>Индия: РМ &quot;Черные списки&quot;</li>
                </ul>
                <h3>v 2.0.142.1</h3>
                <ul>
                    <li>
                        Исправлен баг когда при редактировании пользователя не сохранялись изменения
                    </li>
                    <li>
                        Исправлен баг когда при повторном открытии пользователя его данные не
                        отображались
                    </li>
                    <li>Добавлен пендинг при загрузке ролей</li>
                    <li>Исправлен баг с выгрузкой в эксель</li>
                    <li>Поправлен innerRef в базовом инпуте</li>
                    <li>
                        Отключил рефетч данных при переключении фокуса во вкладке &quot;Заявка&quot;
                        модалки заявок
                    </li>
                </ul>
                <h3>v 2.0.141.1</h3>
                <ul>
                    <li>Добавил скрол в модалке РМ Группы тарифов</li>
                </ul>
                <h3>v 2.0.140.1</h3>
                <ul>
                    <li>Заменены пропсы на валидируемые</li>
                </ul>
                <h3>v 2.0.139.1</h3>
                <ul>
                    <li>Исправлено получение количества заявок</li>
                </ul>
                <h3>v 2.0.138.1</h3>
                <ul>
                    <li>Исправлено получение списка заявок для Колумбии</li>
                </ul>
                <h3>v 2.0.137.1</h3>
                <ul>
                    <li>Исправлена сортировка в РМ действий пользователей</li>
                </ul>
                <h3>v 2.0.136.1</h3>
                <ul>
                    <li>Исправлена работа запросов</li>
                </ul>
                <h3>v 2.0.135.1</h3>
                <ul>
                    <li>Исправлена работа с RefreshToken</li>
                    <li>Обновление Jwt.Key</li>
                    <li>Исправлена ошибка с пустым меню</li>
                </ul>
                <h3>v 2.0.134.1</h3>
                <ul>
                    <li>Исправлена ошибка при маппинге переводов в РМ &quot;Переводчик&quot;</li>
                </ul>
                <h3>v 2.0.133.1</h3>
                <ul>
                    <li>
                        Изменен путь получения отчетов мониторинго. Пути получения вынес в конфиги
                        инстансов
                    </li>
                    <li>Исправлена сборка COL инстанса</li>
                </ul>
                <h3>v 2.0.132.1</h3>
                <ul>
                    <li>Исправлена ошибка при маппинге переводов</li>
                </ul>
                <h3>v 2.0.131.1</h3>
                <ul>
                    <li>Исправлена ошибка при получении списка ролей (десереализация)</li>
                </ul>
                <h3>v 2.0.129.1</h3>
                <ul>
                    <li>Перемещение компонентов рабочих мест в одну папку</li>
                </ul>
                <h3>v 2.0.127.1</h3>
                <ul>
                    <li>Cохранение роли CRM + передача информации о пользователе в CRM</li>
                </ul>
                <h3>v 2.0.126.1</h3>
                <ul>
                    <li>Исправление значения по-умолчанию у экщенов контроллеров</li>
                </ul>
                <h3>v 2.0.125.1</h3>
                <ul>
                    <li>Исправления после рефакторинга baseValidatedDropDownList</li>
                </ul>
                <h3>v 2.0.123.1</h3>
                <ul>
                    <li>
                        Добавил в РМ новый параметр, который отвечает на то, нужно ли обновлять
                        данные при смене языка (по умолчанию false). Применил данную опцию в РМ
                        &quot;Отчеты&quot;
                    </li>
                </ul>
                <h3>v 2.0.122.1</h3>
                <ul>
                    <li>Исправлено меню действий в РМ &quot;Отчеты&quot;</li>
                </ul>
                <h3>v 2.0.121.1</h3>
                <ul>
                    <li>Фиксация пользователя в БД</li>
                </ul>
                <h3>v 2.0.120.1</h3>
                <ul>
                    <li>Исправление заголовков при выгрузке excel в РМ &quot;Отчеты&quot;</li>
                </ul>
                <h3>v 2.0.119.1</h3>
                <ul>
                    <li>Добавлены права доступа к настройкам скоринга</li>
                </ul>
                <h3>v 2.0.118.1</h3>
                <ul>
                    <li>Исправлена ошибка при загрузке файла платежей</li>
                </ul>
                <h3>v 2.0.117.1</h3>
                <ul>
                    <li>Рефакторинг компонента выпадающего списка</li>
                </ul>
                <h3>v 2.0.116.1</h3>
                <ul>
                    <li> Добавлена кнопка вверх в датагриде</li>
                    <li>
                        Исправлен баг отображения фильтра в дропдаун фильтре на маленьких экранах
                    </li>
                    <li>Исправлены баги сайдбара и доработана логика подсветки открытого РМ</li>
                    <li>Исправлена ошибка при изменении существующего перевода</li>
                    <li>
                        В Настройках РМ добавлена проверка на то изменилась ли форма при сабмите
                    </li>
                    <li>При запросах добавлена обработка ошибок не доходящих до react-query</li>
                </ul>
                <h3>v 2.0.113.1</h3>
                <ul>
                    <li>Настройки для VS и VSCode для отладки продукта в разных конфигурациях</li>
                    <li>Курсор ожидания для различных мест</li>
                    <li>Обработка ошибки запроса для различных случаев</li>
                    <li>
                        Если окружение не задано (разработка, тестирование ...) то оно не
                        отображается
                    </li>
                </ul>
                <h3>v 2.0.112.1</h3>
                <ul>
                    <li>
                        Изменение типа кнопки выгрузки файл в excel с submit на button. В Фильтрах
                        РМ при нажатии на ENTER в input полях теперь не будет загружаться excel, а
                        применяться фильтр
                    </li>
                </ul>
                <h3>v 2.0.111.1</h3>
                <ul>
                    <li>Перенос функционала Collections из старого стека в новый ExternalSystem</li>
                    <li>Добавлено игнорирование пробелов в заголовках CSV файлов при их чтении</li>
                </ul>
                <h3>v 2.0.110.1</h3>
                <ul>
                    <li>Испрвлен тултип статусов заявок в меню</li>
                    <li>В РМ Заявки размер страницы по умолчанию 50</li>
                    <li>Исправлены названия статусов в фильтре</li>
                </ul>
                <h3>v 2.0.109.1</h3>
                <ul>
                    <li>Добавлено выключение сайта на &quot;Технические работы&quot;</li>
                </ul>
                <h3>v 2.0.108.1</h3>
                <ul>
                    <li>Исправлен баг с некорректным подключением к сигнал р</li>
                    <li>
                        Исправлен баг когда переводы ролей создавались в группе Admin а не
                        BackOffice
                    </li>
                    <li>Добавлена возможность отключать поиск в дроп дауне</li>
                </ul>
                <h3>v 2.0.107.1</h3>
                <ul>
                    <li>
                        Изменение РМ &quot;Выгрузка реестра на перечисление сумм займов
                        клиенту&quot; для Доминиканы.
                    </li>
                </ul>
                <h3>v 2.0.106.1</h3>
                <ul>
                    <li>Рефакторинг модального окна отказного трафика. Валидация.</li>
                </ul>
                <h3>v 2.0.105.1</h3>
                <ul>
                    <li>
                        Вынесение блокировки пользовательского ввода и курсора ожидания из workplace
                        provider.
                    </li>
                </ul>
                <h3>v 2.0.104.1</h3>
                <ul>
                    <li>
                        Исправлена логика работы с брендами в РМ Переводчик. Бренды теперь
                        используются из таблицы брендов.
                    </li>
                </ul>
                <h3>v 2.0.103.1</h3>
                <ul>
                    <li>Исправлена выгрузка Excel в РМ Настройки</li>
                    <li>Исправлено редактирование в РМ Настройки</li>
                    <li>Исправлен ввод данных в поля в РМ Настройки</li>
                    <li>Сделана валидация полей в РМ Настройки</li>
                    <li>Добавлена кнопка удаления записи в РМ Настройки</li>
                </ul>
                <h3>v 2.0.102.1</h3>
                <ul>
                    <li>
                        Исправлен баг с конфирмом когда при нажатии на отмену закрывалось выпадающее
                        меню с действиями
                    </li>
                    <li>
                        Добавлена обработка нотифаек при откате/накате биллинга в модалке заявки
                    </li>
                    <li>Добавлен стиль для лейбла в базовом инпуте когда тот не активен</li>
                </ul>
                <h3>v 2.0.101.1</h3>
                <ul>
                    <li>Рефакторинг модального окна ролей. Валидация.</li>
                    <li>Модальное окно клиента, заявки: испрвлено начальное состояния чекбокса</li>
                </ul>
                <h3>v 2.0.100.1</h3>
                <ul>
                    <li>Исправление логики проверки при создании отчета.</li>
                    <li>Рефакторинг файла ресурсов: вынесение из него ключений локализации.</li>
                </ul>
                <h3>v 2.0.99.1</h3>
                <ul>
                    <li>
                        Модальное окно клиента, вкладка заявок: по умолчанию показываем только
                        заявки по которые есть выданные займы.
                    </li>
                    <li>Таблица клиентов: по умолчанию не показывать данных</li>
                </ul>
                <h3>v 2.0.98.1</h3>
                <ul>
                    <li>
                        При изменение роли или доступа у залогиненного пользователя, генерируется
                        нотифайка по которой данный пользователь оповещается и разлогинивается
                    </li>
                </ul>
                <h3>v 2.0.97.1</h3>
                <ul>
                    <li>Поправлен блок сайз в модалке заявки</li>
                    <li>Исправлен перевод перевода в гриде заявок</li>
                    <li>Исправлен баг с кривым отображением выбранного языка при переключении</li>
                    <li>Исправлены ошибки виджета в консоли при смене языка</li>
                </ul>
                <h3>v 2.0.96.1</h3>
                <ul>
                    <li>Рефакторинг модального окна отчетов. Валидация.</li>
                </ul>
                <h3>v 2.0.95.1</h3>
                <ul>
                    <li>
                        Модальное окно клиента: заявки, добавлен чекбокс фильтрации таблицы,
                        исправлен запрос получения данных
                    </li>
                </ul>
                <h3>v 2.0.94.1</h3>
                <ul>
                    <li>
                        Модальное окно клиента: открытие информации о заявке в новом модальном окне
                        а не на новой странице.
                    </li>
                    <li>Исправлена верстка таблиц в FireFox</li>
                </ul>
                <h3>v 2.0.93.1</h3>
                <ul>
                    <li>
                        Валидация для модальных окон изменения\добавления бренда, параметров
                        процедур и настройки витрины для отказников
                    </li>
                    <li>Невалидный статус компонента загрузки и отображения картинки</li>
                </ul>
                <h3>v 2.0.92.1</h3>
                <ul>
                    <li>
                        Исправлен баг с отображением ошибки при создании или изменении анкеты
                        клиента
                    </li>
                    <li>Добавлены новые поля для сортировки в рабочем месте заявок</li>
                    <li>Приведены к общему виду лейблы в дропдаун листе</li>
                    <li>
                        Firefox: Исправлен баг с тем что не открывался фильтр в РМ по клику на
                        строку фильтра
                    </li>
                </ul>
            </Wrapper>
        </DocumentTitle>
    );
}
